var _path, _path2, _path3, _path4, _g, _g2, _g3, _path5, _path6, _g4, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g5, _path13, _g6, _g7, _path14, _g8, _path15, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M0 0h1000v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "M0 0h1000v300H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "none",
    strokeWidth: 0.183,
    d: "M405.172 222.414h189.656v155.172H405.172z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    d: "M499.613 332.116v.085c-4.078.43-47.874 5.227-59.775 14.11-12.48 9.316-34.666 19.076-34.666 19.076v11.978h189.656v-11.978s-22.186-9.76-34.666-19.075c-11.9-8.884-55.696-13.68-59.774-14.111v-.085l-.388.042-.387-.042z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "red",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.3,
    d: "M455.739 112.399c-.607-1.578-5.583-1.457-9.467-.243-3.884 1.213-6.068.85-14.443.97-8.374.122-13.108 2.064-13.836 2.307-.728.242-13.35 6.432-18.205 8.01-4.855 1.578-9.467 0-9.467 0s5.583 5.462 13.472 1.092c0 0-6.554 3.641-10.802 4.127 0 0 6.34 1.329 11.697-.986.48-.207.952-.444 1.411-.713 3.354-1.667 6.343-2.96 9.042-3.963 15.357-5.712 21.33-2.075 31.86-4.776",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.322351,-11.271433)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.312,
    d: "M455.711 112.166c-.72 1.395-4.85.613-7.504 1.477.64.562 2.462 1.55 7.587 2.53.85-3.19-.083-4.007-.083-4.007z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.322351,-11.271433)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.3,
    d: "M414.554 122.707c-4.932 1.667-7.314 3.202-10.013 4.206m9.406-5.13c-4.28 1.52-6.738 2.98-9.363 3.992m8.756-4.915c-3.628 1.374-6.161 2.757-8.714 3.776m8.108-4.7c-2.977 1.228-5.585 2.535-8.065 3.562m7.458-4.485a292.844 292.844 0 01-7.415 3.347",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.322351,-11.271433)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.265,
    d: "M420.336 120.264s6.907-2.086 12.251-1.434m-11.47.13s6.485-1.825 12.187-1.336m-11.404.033s6.06-1.564 12.12-1.238m-11.338-.066s5.637-1.303 12.056-1.14m-11.274-.163s5.213-1.043 11.99-1.043",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.322351,-11.271433)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.3,
    d: "M441.841 113.877s3.117-.76 6.25-1.213c2.67-.386 5.353-.55 6.132.17M441.255 114.985s3.64-.407 6.577-1.138M440.668 116.093s4.165-.054 6.905-1.063M440.082 117.2s4.689.3 7.232-.987M439.491 118.203s5.22.582 7.568-.815",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.322351,-11.271433)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    strokeWidth: 1.228,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26 50.929 96.159.408-16.297-48.308-85.025 2.265-1.762-3.258-3.668-1.58.902-.05-.088s-3.26-.406-3.667.817z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.567,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26-3.436-9.23zm57.778 86.565c-1.658.6-4.125 1.578-5.723 2.6l7.031 13.277c1.165-.865 3.418-2.33 5.697-2.615a.782.782 0 00.424-.184z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1800.525 128.34l-1.47.84 2.513 4.55 2.215-1.722z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.228,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26 50.929 96.159.408-16.297-48.308-85.025 2.265-1.762-3.258-3.668-1.58.902-.05-.088s-3.26-.406-3.667.817z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    strokeWidth: 1.228,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26 50.929 96.159.408-16.297-48.308-85.025 2.265-1.762-3.258-3.668-1.58.902-.05-.088s-3.26-.406-3.667.817z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.567,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26-3.436-9.23z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1800.525 128.34l-1.47.84 2.513 4.55 2.215-1.722z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.228,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26 50.929 96.159.408-16.297-48.308-85.025 2.265-1.762-3.258-3.668-1.58.902-.05-.088s-3.26-.406-3.667.817z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.15,
    d: "M471.5 15.643l5.917 16.628 1.803-.686-.661-2.52z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.265,
    d: "M480.036 28.85l-.41.182.542 1.265.628-.395z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.567,
    d: "M1824.676 136.95c-1.97.54-3.731 1.78-5.082 2.95l5.412 13.272c1.624-1.002 3.76-1.909 5.69-2.627z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.325,
    d: "M471.5 15.643l5.917 16.628 1.803-.686 10.87 26.659.538-4.28-10.474-23.658.642-.404-.76-1.052-.44.196-.011-.025s-.847-.192-.987.119z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    strokeWidth: 1.228,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26 50.929 96.159.408-16.297-48.308-85.025 2.265-1.762-3.258-3.668-1.58.902-.05-.088s-3.26-.406-3.667.817z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) rotate(4.1525049,502.68583,103.38745) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.567,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26-3.436-9.23z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) rotate(4.1525049,502.68583,103.38745) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1800.525 128.34l-1.47.84 2.513 4.55 2.215-1.722z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) rotate(4.1525049,502.68583,103.38745) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.228,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26 50.929 96.159.408-16.297-48.308-85.025 2.265-1.762-3.258-3.668-1.58.902-.05-.088s-3.26-.406-3.667.817z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) rotate(4.1525049,502.68583,103.38745) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.15,
    d: "M471.5 15.643l5.917 16.628 1.803-.686-.661-2.52z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) rotate(4.1525049,502.68583,103.38745)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.265,
    d: "M480.036 28.85l-.41.182.542 1.265.628-.395z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) rotate(4.1525049,502.68583,103.38745)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.567,
    d: "M1824.676 136.95c-1.97.54-3.731 1.78-5.082 2.95l5.412 13.272c1.624-1.002 3.76-1.909 5.69-2.627z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) rotate(4.1525049,502.68583,103.38745) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.325,
    d: "M471.5 15.643l5.917 16.628 1.803-.686 10.87 26.659.538-4.28-10.474-23.658.642-.404-.76-1.052-.44.196-.011-.025s-.847-.192-.987.119z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.952308,-11.930329) rotate(4.1525049,502.68583,103.38745)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.5897,-11.271433)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M522.648 69.814l-1.592 15.753-20.026-1.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M561.11 52.433s-1.457 25.124-9.104 37.747l-31.193-4.613.85-15.293 39.446-26.823z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M531.908 13.848c-1.863.819-3.542.164-3.542.164s-.819 1.064 1.392 1.187c0 0 .88.082.287 1.065"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M534.529 11.944s-3.337-2.723-5.446-2.56c-2.109.164-2.211.124-2.396.492-.184.369-.552 2.068.39 3.317.941 1.249 1.33.942 1.494.675.164-.266 1.494-1.044 4.013-.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.15001685999999997,
    d: "M529.284 9.378c-.068 0-.135.001-.201.006-2.109.164-2.211.123-2.396.492-.127.254-.34 1.138-.154 2.072.314-.302.963-.588 2.304-.516 2.662.143 4.218 1.229 4.218 1.229l.263.188 1.21-.905s-3.131-2.555-5.244-2.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M495.602 74.464l23.87-21.751c5.328 2.339 4.918 6.59 1.228 11.935l.111 5.355-19.52 13.608-5.355-1.338-.223-4.908zM496.33 60.457l14.628-18.85 3.7 8.211-1.156 7.748-17.461 16.421z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M511.016 41.954s2.949 6.765 2.486 15.496l17.81-16.594 8.499-7.69-.174.115-1.098-5.319-.52-3.007-1.388.347v-1.734l-.232-1.504-1.214-2.37-.983-2.544-.231-2.14.462-2.544-.636.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M563.748 43.227s1.735 1.734 1.966 5.666c.231 3.932.174 6.65.174 6.65s-2.834 1.676-5.493.982c0 0 .462-1.156.52-2.775.058-1.62-.058-10.003-.058-10.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.15001685999999997,
    d: "M562.13 43.747l-1.272.084c.003.16.114 8.315.057 9.919-.058 1.619-.52 2.775-.52 2.775.973.254 1.968.189 2.84.006.02-.315.338-5.12.282-7.638-.058-2.602-1.387-5.146-1.387-5.146z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M584.63 114.809c.532-1.384 1.969-1.703 1.969-1.703s.106-.107-.32-1.118c-.425-1.011-.213-1.756-.213-1.756.16-5.376-.372-6.813-.372-6.813.372 0 2.076 2.022 2.076 2.022-.054-5.11-7.612-7.505-7.612-7.505 2.768 7.026 1.704 7.825 1.704 7.825 1.756-.746 1.969-1.916 1.969-1.916.32 1.916.053 5.641.053 5.641s.107 1.757-1.543.905c-1.65-.851-8.304-4.045-8.304-4.045l-.692 1.384 9.155 4.258s1.33.586.958 1.597c-.372 1.011-.585 1.17-.585 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M583.884 109.486s.266-3.725-.053-5.641c0 0-.213 1.17-1.97 1.916 0 0 1.065-.799-1.703-7.825 0 0 7.558 2.396 7.612 7.505 0 0-1.704-2.022-2.076-2.022 0 0 .532 1.437.372 6.813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M584.63 114.809c.532-1.384 1.969-1.703 1.969-1.703s.106-.107-.32-1.118c-.425-1.011-.213-1.756-.213-1.756.16-5.376-.372-6.813-.372-6.813.372 0 2.076 2.022 2.076 2.022-.054-5.11-7.612-7.505-7.612-7.505 2.768 7.026 1.704 7.825 1.704 7.825 1.756-.746 1.969-1.916 1.969-1.916.32 1.916.053 5.641.053 5.641s.107 1.757-1.543.905c-1.65-.851-8.304-4.045-8.304-4.045l-.692 1.384 9.155 4.258s1.33.586.958 1.597c-.372 1.011-.585 1.17-.585 1.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M570.684 104.47c-.21 0-.63.048-.977.321a.984.984 0 00-.367.61c-.045.265.01.576.183.937.36.75 1.077 1.025 1.664 1.103a3.606 3.606 0 001.084-.023l-.087-.441s-.434.085-.938.017c-.504-.067-1.037-.27-1.316-.851-.146-.305-.172-.52-.147-.668a.498.498 0 01.201-.328c.212-.167.59-.225.7-.225.184 0 .344-.03.644.121.3.15.73.497 1.303 1.277l.363-.267c-.598-.816-1.073-1.217-1.465-1.412-.391-.196-.71-.17-.845-.17z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M571.376 109.274s.213-3.513 2.449-4.738c0 0 .532.054.585.48.053.425-2.076 4.151-2.076 4.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.125,
    d: "M571.629 108.879s.177-2.927 2.04-3.947c0 0 .443.044.488.4.044.354-1.73 3.458-1.73 3.458z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.147,
    cy: 100.305,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M581.874 75.422s4.03.232 3.983 2.223c-.046 1.992-.648 3.937.695 4.308 1.343.37 4.122.37 4.817 1.111.694.741.694 1.575.694 1.575s-3.473-1.25-5.002-.37c-1.528.88-3.128-.51-3.38-.973-.557-1.02-.232-3.01-1.298-3.381-1.065-.37-4.446-.417-4.446-.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M552.633 48.008c.63-10.867-1.26-23.623-1.26-23.623l-.158-1.89-32.6 31.183s2.209 3.313 1.882 16.534l2.528-1.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M552.633 48.008c.63-10.867-1.26-23.623-1.26-23.623l-.158-1.89"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f1b517",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M543.911-1.2l-4.364 10.177s-1.269-1.29-2.296.048l-1.024 1.333m7.668-11.57l-8.424 7.187s1.607.83.635 2.207l-.968 1.374 1.089.802"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M532.89 7.305l5.994 4.385-1.573 2.15-5.994-4.384z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.15,
    d: "M533.023 7.966l5.19 3.797-1.035 1.417-5.19-3.797z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1b517",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M563.286 11.409l-5.922 9.356s-1.049-1.474-2.275-.316l-1.222 1.153m9.405-10.208l-9.457 5.761s1.456 1.074.278 2.28l-1.175 1.203.949.964"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M551.056 18.06l5.224 5.279-1.895 1.874-5.223-5.28z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.15,
    d: "M551.083 18.733l4.523 4.572-1.248 1.234-4.523-4.571z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1b517",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M575.896 32.689l-7.438 8.203s-.78-1.632-2.187-.701l-1.402.927m11.015-8.446l-10.304 4.055s1.25 1.308-.117 2.294l-1.363.984.769 1.113"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M562.707 37.145l4.242 6.097-2.188 1.522-4.242-6.097z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.15,
    d: "M562.618 37.814l3.673 5.279-1.441 1.002-3.673-5.279z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M534.065 11.472l-37.87 48.098.59.463 37.87-48.098zM550.418 23.229L495.662 74.02l.51.551 54.756-50.795zM559.232 43.568L500.94 83.467l.424.619 58.293-39.898z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M552.99 23.897s-5.495-1.05-6.833-.238 2.342.86 3.059.62l-1.386 1.387s-3.154-.765-3.68-3.728c-.525-2.963 1.577-2.963 2.055-2.915.478.048 3.25.478 6.786 4.874z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M545.101 20.784c-.604.18-1.059.604-.903 1.393 0 0 .239.908.478 1.386a.304.304 0 01.073-.084c.181.283.387.533.606.753a6.4 6.4 0 01.539-.177c-.068-.104-.003-.235.263-.396.149-.09.35-.156.587-.205.998-.383 2.491.014 2.806-.034l1.673.095s-4.98-3.07-6.122-2.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M550.793 23.324s-6.125-1.831-6.125-.063"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M552.99 23.897s-5.495-1.05-6.833-.238 2.342.86 3.059.62l-1.386 1.387s-3.154-.765-3.68-3.728c-.525-2.963 1.577-2.963 2.055-2.915.478.048 3.25.478 6.786 4.874z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M552.275 23.853c-.143.69-.301 1.596-.22 2.002 1.79 4.572 4.223 4.671 3.27 10.226l1.884-.053c.204-2.577-.203-5.018-.678-6.103-.237-.543-.763-1.187-1.339-1.815-.577-.627-1.204-1.237-1.645-1.712-.882-.95-.271-2.17-.271-2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M551.106 23.414s-.332.874-.332 2.1c0 .613.083 1.313.332 2.037.249.723.46 1.44.633 2.233.347 1.588.542 3.487.587 6.38l2.998-.083c.954-5.555-1.48-5.654-3.269-10.226-.081-.406.077-1.312.22-2.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M553.276 24.228s-.61 1.22.271 2.17c.441.475 1.068 1.085 1.645 1.712.576.628 1.102 1.272 1.34 1.815.474 1.085.88 3.526.677 6.103m0 0l-4.882.136c-.046-2.894-.242-4.793-.588-6.38a19.598 19.598 0 00-.633-2.233 6.261 6.261 0 01-.332-2.037c0-1.226.332-2.1.332-2.1l2.17.814"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M553.886 36.096s.679-3.052-.881-5.764c-1.57-2.774-2.04-6.994-1.221-6.715"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.157,
    d: "M548.427 80.397l-4.218 7.38-16.665 1.24-1.575.212s-2.434 5.738-5.137 6.503c-2.703.764-20.78 6.402-20.78 6.402l-.557-4.133 11.715-3.78s3.437-1.264 4.46-2.604c1.021-1.34 9.543-9.5 9.543-9.5z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M540.959 61.578l-24.223 40.371.514.309 24.223-40.371z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M540.471 63.209s.684.647 1.533-.389c.85-1.036 3.332-5.311 3.807-6.088.475-.778 1.087-1.425.28-1.944-.805-.518-1.935.13-2.864 2.073-.928 1.943-3.98 5.311-2.756 6.348z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.15736518,
    d: "M561.907 68.754c.905-.122 2.45 1.647 2.863 4.722.413 3.075.016 5.666-.889 5.787-.33.043-.7-.257-1.058-.858l-48.357 6.505-1.018-9.136 47.977-5.7c.156-1.177.028-1.257.482-1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4cf0e",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15,
    d: "M262.965 61.762s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.082m-.727-1.057s-.206.664-.277 1.08m-.726-1.056s-.207.664-.277 1.081m-.727-1.057s-.206.664-.277 1.081m-.726-1.057s-.206.664-.277 1.082m-.726-1.057s-.207.664-.277 1.08m-.727-1.056s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.081m-.727-1.057s-.206.664-.277 1.081m-.726-1.056s-.207.664-.277 1.08m-.727-1.056s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.081m-.727-1.057s-.206.664-.277 1.081m-.726-1.056s-.206.664-.277 1.08m-.726-1.056s-.207.664-.277 1.081m-.727-1.057s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.081m-.727-1.057s-.206.665-.277 1.082m-.726-1.057s-.207.664-.277 1.08m-.727-1.056s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.081m-.727-1.057s-.206.665-.277 1.082m-.726-1.057s-.206.664-.277 1.08m-.726-1.056s-.207.664-.277 1.081m-.727-1.057s-.206.664-.277 1.081m-.726-1.057s-.207.665-.277 1.082m-.727-1.057s-.206.664-.277 1.08m-.726-1.056s-.207.664-.277 1.081m-.727-1.057s-.206.664-.277 1.081m-.726-1.057s-.207.665-.277 1.082m-.727-1.057s-.206.664-.277 1.08m-.726-1.056s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.081m-.727-1.057s-.206.665-.277 1.082m-.726-1.057s-.207.664-.277 1.08m-.727-1.056s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.081m-.727-1.057s-.206.665-.277 1.082m-.726-1.057s-.207.664-.277 1.08m-.727-1.056s-.206.664-.277 1.081m-.726-1.057s-.206.664-.277 1.081m-.726-1.057s-.207.665-.277 1.082m-.727-1.057s-.206.664-.277 1.08m-.726-1.056s-.207.664-.277 1.081",
    transform: "matrix(-1.0396243,0.13985207,0.13985207,1.0396243,780.1168,-25.809613) matrix(1.000553,0,0,0.70120787,-0.08578216,18.848186)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.27798235000000004,
    d: "M563.078 73.084l-48.972 6.587M563.226 74.184l-48.972 6.588M563.374 75.284l-48.972 6.588M563.448 75.834l-48.972 6.588M563.522 76.384l-48.972 6.588M563.596 76.935l-48.972 6.587M563.67 77.485l-48.972 6.588M563.744 78.035l-48.972 6.588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1573485,
    d: "M554.628 70.105a1.544 5.091-4.009 011.895 4.982 1.544 5.091-4.009 01-1.19 5.175 1.544 5.091-4.009 01-.484-.216 1.544 5.091-4.009 00.68-4.825 1.544 5.091-4.009 00-1.409-4.766 1.544 5.091-4.009 01.508-.35zM520.381 74.712a1.544 5.091-4.009 011.894 4.982 1.544 5.091-4.009 01-1.189 5.175 1.544 5.091-4.009 01-.485-.216 1.544 5.091-4.009 00.682-4.825 1.544 5.091-4.009 00-1.41-4.766 1.544 5.091-4.009 01.508-.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.1573485,
    d: "M513.207 78.799l-2.731-.184s-1.677.576-1.78 1.292c-.105.715-.163 1.776-.025 2.058.139.282 3.323.856 4.44-.147z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.696 79.906c1.092.268 3.02.16 4.476.02l-.06 1.892c-1.118 1.002-4.302.429-4.44.147-.139-.282-.08-1.343.023-2.058v-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15736518,
    d: "M513.714 75.526a1.073 4.923-3.743 01.333.2 1.07 5.213-3.989 00-.177 4.388 1.07 5.213-3.989 00.947 4.653 1.073 4.923-3.743 01-.45.584 1.073 4.923-3.743 01-1.395-4.818 1.073 4.923-3.743 01.742-5.007z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,984.9863,0.74097931)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15001685999999997,
    d: "M443.728 74.86v.033c.553.125.965.615.965 1.207v8.27l-5.847-5.848a1.235 1.235 0 01-.172-1.535l-.024-.023-2.533 2.533.01.01a1.233 1.233 0 011.646.088l5.945 5.944h-8.465c-.592 0-1.082-.41-1.207-.963h-.033v3.582h.014c.069-.62.586-1.102 1.226-1.102h8.408l-5.985 5.985a1.236 1.236 0 01-1.536.172l-.023.024 2.533 2.533.01-.01a1.233 1.233 0 01.088-1.646l5.945-5.945v8.464c0 .592-.412 1.082-.965 1.208v.033h3.583v-.014a1.233 1.233 0 01-1.102-1.227V88.03l6.083 6.084c.453.452.478 1.158.088 1.646l.01.01 2.534-2.533-.024-.024a1.235 1.235 0 01-1.536-.172l-5.985-5.985h8.407c.64 0 1.157.481 1.226 1.102h.014v-3.582h-.033a1.235 1.235 0 01-1.207.963h-8.464l5.945-5.944a1.233 1.233 0 011.646-.088l.01-.01-2.534-2.533-.023.023c.303.48.247 1.117-.171 1.535l-5.986 5.986V76.1c0-.64.481-1.157 1.102-1.226v-.014z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 86.476,
    r: 2.282,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15001685999999997,
    d: "M445.45 71.277a15.09 15.09 0 00-15.089 15.09 15.09 15.09 0 0015.09 15.09 15.09 15.09 0 0015.09-15.09 15.09 15.09 0 00-15.09-15.09zm0 3.84a11.25 11.25 0 0111.25 11.25 11.25 11.25 0 01-11.25 11.25 11.25 11.25 0 01-11.25-11.25 11.25 11.25 0 0111.25-11.25z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45,445.45132,86.297958)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.70710678,0.70710678,0.70710678,0.70710678,699.4111,-289.70556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,359.15336,-359.15336)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.37566452,0.92675572,0.92675572,-0.37566452,198.13393,-294.10752)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(113.39109,445.45132,86.297957)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(23.077806,445.45132,86.297956)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.9199734,0.39198079,0.39198079,0.9199734,821.42755,-167.70223)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 556.963,
    cy: 100.305,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M498.222 68.61s5.88 2.533 6.386-1.826c0 0 3.548 4.46-1.317 7.3 0 0 2.23-3.549-5.069-3.954 0 0-1.014.101-.912-.71.101-.81.912-.81.912-.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.303 69.56c.833.074 2.733.284 5.684.874 1.31.262 2.226.1 2.87-.239.008 1.29-.572 2.725-2.567 3.888 0 0 2.23-3.548-5.068-3.953 0 0-.892.089-.919-.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M500.814 68.572l.494.074-2.027 13.584-.495-.074z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M500.615 68.543l.89.133-.408 2.736-.89-.133z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.15,
    transform: "matrix(-1,0,0,1,984.5452,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 472.443,
    cy: 104.751,
    fill: "#fff",
    rx: 3.569,
    ry: 1.681
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f1b517"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.15001685999999997,
    d: "M472.761 84.818c-.33-.016-.648.039-.736.236-.175.396.352.483.352.483v2.24c0 .703-.571 11.287-.835 13.35a7.687 7.687 0 01-.467 1.851s-2.52.302-2.387 1.444c.131 1.141 1.493 1.896 3.777 1.844 2.815-.064 3.601-.659 3.733-1.361.132-.703-.659-1.361-1.845-1.581l-.614-3.514s.131.527 1.756.176c1.625-.351 1.581-2.81 1.581-2.81s.044-7.38-.044-8.74c-.087-1.362-.834-2.02-1.888-2.416-.835-.132-1.406.044-1.493.527-.088.483-.308.615-.44.44-.131-.176 0-1.494 0-1.494s.615-.307.352-.483c-.132-.088-.472-.175-.802-.192zm2.12 2.52l.57.307.176 1.581v7.993l-.088.527-.747.615-.834-.176-.44-.527-.307-7.158-.087-2.284 1.054-.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M474.573 104.158s-.966-2.46-1.186-8.915c-.22-6.456-.307-6.983 0-7.29.307-.308 1.186-.835 1.713-.527.527.307.395.395.483 1.493.088 1.098.088 8.212.088 8.212s-.264 1.186-.923 1.142c-.658-.044-1.141-.307-1.23-.79"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M470.357 104.29s.922-1.098 1.185-3.162c.264-2.064.835-12.648.835-13.351v-2.24"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.265,
    d: "M524.804 96.618s-3.224.095-4.267 2.087c-1.043 1.991-.474 3.888.759 4.647 1.232.758 3.888 1.327 5.12.569 1.233-.76 2.087-3.225.664-3.51-1.422-.284-3.793-.758-3.508-1.706.284-.949 1.517-.949 1.517-.949z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.15,
    d: "M491.59 178.412h.597v2.147h-.597z",
    transform: "matrix(0.98736087,-0.1584882,0.21855532,0.97582456,0,0)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M570.121 86.252l-13.617 7.086.072.138.958.173 12.934-6.733z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M570.523 86.586l-7.673 13.586 1.245-.68 7.083-12.539z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.64 73.375a.375.375 0 00-.004 0 .375.375 0 00-.258.114l-12.924 12.83a.375.375 0 10.53.53l12.704-12.611v-.86a.375.375 0 00-.049-.003z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    d: "M572.558 84.398a.375.375 0 00-.257.114L559.47 97.249l1.123-.057 12.235-12.147a.375.375 0 00-.27-.647z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.951,
    cy: 109.883,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 529.652,
    cy: 105.094,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538.432,
    cy: 105.664,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.104,
    cy: 109.313,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 550.919,
    cy: 109.313,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.735,
    cy: 109.313,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.55,
    cy: 109.313,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.069,
    cy: 104.866,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.884,
    cy: 104.866,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.699,
    cy: 104.866,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M535.734 13.089s-.187 1.876 1.408 3.002 3.471 2.346 4.222 5.536c.75 3.19.187 2.815.187 2.815l-4.972.844s.563-2.252-.657-4.034c-1.22-1.783-3.002-6.943-1.314-9.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.15001685999999997,
    d: "M535.576 12.97c-.296.726-.815 2.451.346 3.684 1.501 1.595 2.908 2.346 3.471 4.504.337 1.292.561 2.622.697 3.531l1.461-.248s.563.376-.187-2.814-2.627-4.41-4.222-5.535c-1.595-1.126-1.408-3.003-1.408-3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M534.984 12.15s-.939 2.159.094 4.317c1.032 2.158 2.064 3.19 2.627 4.597.563 1.407 0 2.72.656 3.753"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15,
    d: "M573.904 106.957a.2.2 0 10.063.395s3.398-.534 5.924 2.04a.2.2 0 10.285-.279c-2.671-2.722-6.272-2.156-6.272-2.156z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M579.832 110.797s-.007.534.43 1.047c.436.512 1.302 1.005 2.963 1.056l.011-.4c-1.587-.049-2.319-.504-2.67-.916-.35-.412-.334-.777-.334-.777z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M584.63 114.809c.532-1.384 1.969-1.703 1.969-1.703s.106-.107-.32-1.118c-.425-1.011-.213-1.756-.213-1.756.16-5.376-.372-6.813-.372-6.813.372 0 2.076 2.022 2.076 2.022-.054-5.11-7.612-7.505-7.612-7.505 2.768 7.026 1.704 7.825 1.704 7.825 1.756-.746 1.969-1.916 1.969-1.916.32 1.916.053 5.641.053 5.641s.107 1.757-1.543.905c-.883-.455-5.162-2.53-5.162-2.53l-.408 1.462 5.73 2.665s1.33.586.957 1.597c-.372 1.011-.585 1.17-.585 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.839 106.91c.068.127.136.26.206.404.095.004.195.01.3.018a13.166 13.166 0 00-.202-.412 8.294 8.294 0 00-.304-.01zm1.013.08c.047.132.093.268.14.418.095.016.194.037.292.057a12.51 12.51 0 00-.138-.43 8.167 8.167 0 00-.294-.046zm1.092.226c.024.137.047.28.068.434.091.028.183.059.276.092-.02-.155-.04-.3-.063-.438-.095-.03-.188-.062-.28-.088zm1.092.398c-.003.14-.007.284-.015.437.086.041.172.085.258.132a12.7 12.7 0 00.02-.437c-.088-.045-.176-.092-.264-.132zm1.006.56c-.028.136-.058.276-.092.42.077.054.155.111.232.17.036-.147.065-.286.095-.425a7.103 7.103 0 00-.235-.164zM580.476 111.465l-.19.404c.06.067.127.133.201.198l.178-.38c-.034-.035-.07-.07-.098-.103a1.608 1.608 0 01-.09-.119zm.544.498l-.05.434c.077.042.163.081.252.12l.048-.417a2.541 2.541 0 01-.25-.137zm.633.29l.08.44a5 5 0 00.28.067l-.077-.427a4.032 4.032 0 01-.283-.08zm.566.144l.186.43c.1.014.199.029.306.039l-.185-.425c-.105-.013-.212-.027-.307-.044z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M560.742 38.89s-3.007-1.445-3.7-.231c-.695 1.214-.984 3.642 0 5.088 0 0 4.278.52 6.475-.231l.29-.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.15001685999999997,
    d: "M557.76 40.215c-.477-.01-.934.138-1.295.307-.147 1.11-.02 2.348.576 3.225 0 0 3.788.46 6.066-.112-1.096-.344-2.984-2.154-4.273-3.068a1.896 1.896 0 00-1.074-.352z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M556.463 42.648s1.445-.983 3.758.058c2.313 1.04 2.313.867 2.313.867"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M560.742 38.89s-3.007-1.445-3.7-.231c-.695 1.214-.984 3.642 0 5.088 0 0 4.278.52 6.475-.231l.29-.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M561.609 43.805s.462 1.966.578 6.07c.116 4.106-.752 6.881-1.098 6.824"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M563.748 43.227s1.735 1.734 1.966 5.666c.231 3.932.174 6.65.174 6.65s-2.834 1.676-5.493.982c0 0 .462-1.156.52-2.775.058-1.62-.058-10.003-.058-10.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M537.903 24.955s1.387 5.725 1.56 8.384"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M527.158 13.193s1.413-1.925 5.59-.246"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    stroke: "#000",
    strokeWidth: 0.287,
    d: "M499.143-5.188l.824-27.052 3.845-2.06 1.099 29.112z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.325,
    d: "M500.72-56.993s-.372 0-.99-.62c-.62-.618-.99-.618-.496-1.485.495-.866 1.114-1.98 3.219-1.857 2.104.124 3.714.248 4.456 2.476.743 2.228.99 8.17.372 10.646-3.219-.124-8.047-2.723-8.79-4.456-.742-1.733 2.229-4.704 2.229-4.704z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    strokeWidth: 1.228,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26 50.929 96.159.408-16.297-48.308-85.025 2.265-1.762-3.258-3.668-1.58.902-.05-.088s-3.26-.406-3.667.817z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.567,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26-3.436-9.23zm57.778 86.565c-1.658.6-4.125 1.578-5.723 2.6l7.031 13.277c1.165-.865 3.418-2.33 5.697-2.615a.782.782 0 00.424-.184z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1800.525 128.34l-1.47.84 2.513 4.55 2.215-1.722z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.228,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26 50.929 96.159.408-16.297-48.308-85.025 2.265-1.762-3.258-3.668-1.58.902-.05-.088s-3.26-.406-3.667.817z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    strokeWidth: 1.228,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26 50.929 96.159.408-16.297-48.308-85.025 2.265-1.762-3.258-3.668-1.58.902-.05-.088s-3.26-.406-3.667.817z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.567,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26-3.436-9.23z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1800.525 128.34l-1.47.84 2.513 4.55 2.215-1.722z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.228,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26 50.929 96.159.408-16.297-48.308-85.025 2.265-1.762-3.258-3.668-1.58.902-.05-.088s-3.26-.406-3.667.817z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.15,
    d: "M471.5 15.643l5.917 16.628 1.803-.686-.661-2.52z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.265,
    d: "M480.036 28.85l-.41.182.542 1.265.628-.395z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.567,
    d: "M1824.676 136.95c-1.97.54-3.731 1.78-5.082 2.95l5.412 13.272c1.624-1.002 3.76-1.909 5.69-2.627z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.325,
    d: "M471.5 15.643l5.917 16.628 1.803-.686 10.87 26.659.538-4.28-10.474-23.658.642-.404-.76-1.052-.44.196-.011-.025s-.847-.192-.987.119z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    strokeWidth: 1.228,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26 50.929 96.159.408-16.297-48.308-85.025 2.265-1.762-3.258-3.668-1.58.902-.05-.088s-3.26-.406-3.667.817z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) rotate(4.1525049,502.68583,103.38745) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.567,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26-3.436-9.23z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) rotate(4.1525049,502.68583,103.38745) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1800.525 128.34l-1.47.84 2.513 4.55 2.215-1.722z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) rotate(4.1525049,502.68583,103.38745) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.228,
    d: "M1763.447 81.89l28.522 60.303 6.52-3.26 50.929 96.159.408-16.297-48.308-85.025 2.265-1.762-3.258-3.668-1.58.902-.05-.088s-3.26-.406-3.667.817z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) rotate(4.1525049,502.68583,103.38745) rotate(5.7228108,529.2951,67.882023) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.15,
    d: "M471.5 15.643l5.917 16.628 1.803-.686-.661-2.52z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) rotate(4.1525049,502.68583,103.38745)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.265,
    d: "M480.036 28.85l-.41.182.542 1.265.628-.395z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) rotate(4.1525049,502.68583,103.38745)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.567,
    d: "M1824.676 136.95c-1.97.54-3.731 1.78-5.082 2.95l5.412 13.272c1.624-1.002 3.76-1.909 5.69-2.627z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) rotate(4.1525049,502.68583,103.38745) scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.325,
    d: "M471.5 15.643l5.917 16.628 1.803-.686 10.87 26.659.538-4.28-10.474-23.658.642-.404-.76-1.052-.44.196-.011-.025s-.847-.192-.987.119z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1036.2249,-11.930329) rotate(4.1525049,502.68583,103.38745)"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.287,
    d: "M505.052-56.08s-2.6.496-2.475 1.734",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.287,
    d: "M503.815-58.85s-2.971.743-3.962 3.342M502.453-58.479s-1.733 1.486-2.476.99",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.287,
    d: "M499.532-54.898c-.114.004-.174.01-.174.01l-.344.097c-.495.846-.831 1.78-.522 2.502.053.123.128.251.22.383l.274-.136s5.695-.495 8.17 3.838l.149.259c.235-1.02.335-2.566.323-4.197-3.944-2.715-7.309-2.783-8.096-2.756z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.287,
    d: "M506.167-54.718s-1.362.62-1.362 1.238",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M495.559 5.491s1.67 54.99.304 75.65m-.304-75.65c-1.984-.304-5.308 0-5.308 0s-1.67 54.99-.304 75.65c0 0 3.628-.456 5.916 0",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.1027993,0,0,1.0843392,-41.468682,-11.269812)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M499.835 271.807a65.098 65.098 0 00-2.254.049l-.005.222a66.84 66.84 0 014.804-.008l-.006-.222a66.163 66.163 0 00-2.539-.04zm-.025 1.619a68.616 68.616 0 00-2.273.044l-.005.224a71.53 71.53 0 014.892-.002l-.006-.223a70.694 70.694 0 00-2.608-.043zm-.025 1.62a78.726 78.726 0 00-2.292.04l-.006.222a77.035 77.035 0 014.982.004l-.006-.222a76.237 76.237 0 00-2.678-.044zm-.026 1.62a86 86 0 00-2.31.036l-.006.222a83.593 83.593 0 015.07.01l-.006-.223a82.797 82.797 0 00-2.748-.045zm-.948 1.625c-.515.005-.972.015-1.402.026l-.005.223a91.302 91.302 0 015.148.015l-.005-.223a91.814 91.814 0 00-3.736-.04zm-.023 1.618c-.52.004-.984.012-1.417.022-.003.071-.004.15-.006.223 1.36-.03 3.175-.042 5.225.02l-.005-.223a100.963 100.963 0 00-3.797-.042zm-.022 1.619c-.527.003-.997.01-1.433.018l-.006.223c1.37-.026 3.216-.034 5.302.026l-.006-.223a113.6 113.6 0 00-3.857-.044zm-.024 1.619c-.532.002-1.008.008-1.448.014l-.005.221c1.381-.02 3.256-.026 5.378.032l-.006-.222c-1.443-.039-2.78-.05-3.92-.045zm-.022 1.617c-.539 0-1.022.005-1.464.01-.003.083-.003.14-.005.224 1.392-.017 3.294-.018 5.454.036-.003-.083-.004-.14-.005-.224-1.47-.037-2.826-.048-3.98-.046zm-.022 1.62c-.543 0-1.031.002-1.476.006-.003.072-.003.149-.005.222 1.402-.012 3.33-.01 5.521.04l-.004-.222a177.502 177.502 0 00-4.036-.046zm-.024 1.617c-.547 0-1.039 0-1.485.002l-.005.223c1.41-.007 3.364 0 5.587.046l-.004-.223a221.775 221.775 0 00-4.093-.048zm-.022 1.62c-.625-.004-1.005 0-1.496 0l-.004.222c1.428-.002 3.301.003 5.652.047l-.005-.222a295.02 295.02 0 00-4.147-.048zm-1.525 1.614c-.002.073-.002.148-.003.222 1.433.003 3.329.013 5.708.05l-.004-.22a407.873 407.873 0 00-5.7-.052zm-.027 1.613c-.003.075-.003.148-.005.223 1.419.008 2.983.018 5.765.055l-.004-.222c-2.778-.037-4.34-.048-5.757-.056zm-.029 1.612l-.003.222 5.82.061-.004-.222-5.813-.061zm-.024 1.61c0 .075-.002.15-.003.224 1.42.022 3.026.044 5.868.066 0-.074-.003-.15-.004-.224-2.839-.021-4.443-.043-5.86-.065zm-.022 1.616c0 .074-.003.147-.004.222 1.453.027 3.426.058 5.913.069 0-.075-.002-.15-.003-.224-2.485-.01-4.455-.04-5.907-.067zm-.023 1.612c0 .075-.003.148-.003.223 1.456.033 3.446.068 5.958.07 0-.074-.003-.146-.003-.221-2.51-.003-4.498-.038-5.952-.072zm-.02 1.618l-.002.222c1.454.038 3.564.075 5.995.07l-.002-.223c-2.43.005-4.539-.03-5.991-.07zm-.016 1.613l-.002.223c1.457.045 3.578.084 6.027.07l-.002-.222c-2.448.014-4.568-.026-6.023-.07zm-.016 1.614c0 .075-.003.148-.003.222 1.46.051 3.593.094 6.06.071l-.002-.222c-2.466.023-4.598-.02-6.055-.07zm-.015 1.615v.222c1.465.057 3.597.108 6.087.076v-.224a118.69 118.69 0 01-6.085-.074zm-.008 1.613v.223c1.466.063 3.601.118 6.103.076v-.223c-2.502.042-4.639-.013-6.101-.076zm-.008 1.615v.223a91.3 91.3 0 006.12.076c0-.074 0-.148-.002-.222a90.99 90.99 0 01-6.118-.077zm-.008 1.614l-.002.223c1.468.076 3.61.138 6.136.076v-.223c-2.527.063-4.67 0-6.134-.076zm0 1.615v.223c1.467.081 3.604.148 6.132.075v-.222c-2.531.073-4.67.006-6.133-.076zm.002 1.616v.222c1.466.087 3.598.157 6.13.074v-.223a67.152 67.152 0 01-6.13-.073zm.003 1.614v.222a61.8 61.8 0 006.126.073v-.222a61.61 61.61 0 01-6.126-.073zm.01 1.617l.001.222c1.46.098 3.58.173 6.103.07l.002-.223a57.02 57.02 0 01-6.106-.07zm.014 1.616c0 .074 0 .149.002.223 1.456.103 3.56.18 6.074.067 0-.073 0-.148.002-.222-2.52.114-4.626.036-6.077-.068zm.013 1.617l.003.223c1.452.108 3.542.187 6.045.064l.002-.222c-2.51.123-4.603.043-6.05-.065zm.022 1.618c0 .074.002.148.004.222 1.445.112 3.516.192 5.999.061l.003-.222a46.244 46.244 0 01-6.006-.061zm.028 1.617l.005.224c1.437.116 3.483.196 5.94.057.003-.076.004-.148.005-.223-2.468.14-4.518.059-5.95-.058zm.035 1.62c.003.074.004.15.006.223a41.35 41.35 0 005.868.052c.003-.072.004-.149.005-.222a40.974 40.974 0 01-5.878-.053zm.045 1.621l.006.222a39.15 39.15 0 005.777.047l.006-.222c-2.393.154-4.38.075-5.79-.047zm.053 1.622l.01.223c1.398.122 3.338.195 5.665.04l.008-.222a36.862 36.862 0 01-5.683-.041zm.065 1.623l.011.224c1.378.122 3.27.191 5.531.034l.011-.224c-2.279.16-4.178.089-5.553-.034zm.08 1.626c.004.078.01.147.013.224 1.353.12 3.188.182 5.367.026l.014-.225c-2.2.16-4.044.096-5.394-.025z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M493.097 79.065c.371.043.784.083 1.236.117m-1.231-2.03c.376.04.796.079 1.257.111m-1.253-2.025c.382.039.809.075 1.278.106m-1.273-2.02c.386.037.82.072 1.298.102m-1.294-2.015c.392.035.834.068 1.32.096m-1.315-2.01c.397.034.846.064 1.34.091m-1.336-2.004c.403.031.859.06 1.361.085m-1.356-1.998c.408.029.87.056 1.382.08m-1.378-1.993c.413.026.884.052 1.403.074m-1.398-1.988c.418.025.895.048 1.424.069m-1.42-1.982c.424.023.908.044 1.445.063m-1.44-1.977c.429.021.92.04 1.465.059m-1.46-1.972c.434.019.932.036 1.486.053m-1.482-1.966c.44.016.945.032 1.507.047m-1.503-1.96c.445.014.958.028 1.528.041m-1.523-1.955c.45.013.97.025 1.549.036m-1.545-1.95c.456.011.983.021 1.57.032m-1.565-1.945c.46.009.995.017 1.59.026m-1.63-1.94c.466.008 1.008.014 1.612.021m-1.654-1.933l1.633.015m-1.675-1.928c.477.002 1.033.005 1.654.01m-1.695-1.924c.482.001 1.045.002 1.674.005m-1.716-1.918c.487-.001 1.057-.002 1.695 0m-1.737-1.913c.493-.003 1.07-.007 1.716-.006m-1.758-1.907c.498-.005 1.083-.01 1.737-.012m-1.778-1.901c.503-.008 1.094-.015 1.757-.018m-1.8-1.896c.51-.009 1.108-.018 1.78-.022m-1.821-1.89c.514-.012 1.12-.023 1.8-.029m-1.842-1.885c.52-.013 1.132-.026 1.82-.033m-1.862-1.88c.525-.015 1.145-.03 1.842-.039m-1.883-1.874c.53-.018 1.157-.034 1.862-.044m-1.904-1.87c.535-.019 1.17-.037 1.883-.049m-1.925-1.864c.54-.02 1.182-.041 1.904-.054m-1.946-1.859a86.342 86.342 0 011.925-.06m-1.966-1.853c.55-.025 1.207-.05 1.945-.066m-1.987-1.847c.556-.027 1.22-.054 1.966-.071m-2.008-1.843c.562-.029 1.232-.057 1.988-.076m-2.03-1.837a72.092 72.092 0 012.009-.081",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.1027993,0,0,1.0843392,-41.468682,-11.269812) translate(1.1855043,-0.79937208)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M493.736 79.065c.37.043.784.083 1.236.117m-1.274-2.036c.376.04.796.079 1.257.111m-1.296-2.03c.382.038.809.075 1.278.106m-1.316-2.026c.387.037.821.072 1.299.101m-1.337-2.02c.392.035.833.068 1.32.096m-1.359-2.015c.398.033.846.063 1.34.09m-1.378-2.01c.403.031.858.06 1.361.085m-1.4-2.004c.409.03.872.056 1.383.08m-1.42-1.999c.413.027.883.052 1.402.074m-1.44-1.993c.418.025.895.048 1.423.069m-1.462-1.988c.423.023.908.044 1.444.063m-1.483-1.982c.43.02.921.04 1.466.058m-1.504-1.978c.434.02.933.037 1.487.053m-1.525-1.972c.44.017.945.033 1.507.048m-1.546-1.967c.445.015.958.029 1.529.042m-1.567-1.961c.45.013.97.025 1.55.036m-1.557-1.955l1.57.031m-1.537-1.95c.46.009.995.017 1.59.026m-1.558-1.945c.466.007 1.008.013 1.612.02m-1.58-1.939l1.633.015m-1.6-1.934c.476.003 1.032.005 1.653.01m-1.622-1.929c.483 0 1.046.001 1.675.004m-1.642-1.923c.487-.001 1.057-.002 1.695 0m-1.663-1.919c.493-.003 1.07-.006 1.716-.006m-1.684-1.913c.498-.005 1.083-.01 1.737-.011m-1.705-1.908c.504-.007 1.095-.014 1.758-.017m-1.726-1.901c.509-.01 1.108-.019 1.78-.023m-1.747-1.896c.514-.012 1.12-.022 1.8-.028m-1.768-1.891c.519-.013 1.132-.026 1.82-.033m-1.788-1.886c.525-.015 1.145-.03 1.841-.039m-1.809-1.88c.53-.017 1.157-.034 1.862-.044m-1.83-1.875c.536-.02 1.17-.038 1.884-.05m-1.851-1.869c.54-.021 1.182-.042 1.904-.055m-1.872-1.864a86.342 86.342 0 011.925-.06m-1.893-1.859c.551-.025 1.207-.05 1.946-.065m-1.914-1.854c.557-.027 1.22-.053 1.967-.07m-1.935-1.849c.562-.029 1.232-.057 1.988-.076M493.83 8.06a72.093 72.093 0 012.008-.081",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.1027993,0,0,1.0843392,-41.468682,-11.269812) translate(-3.4983431,-0.692921)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.322351,-11.271433)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M521.42 70.274l-.364 15.293-20.026-1.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M561.11 52.433s-1.457 25.124-9.104 37.747l-31.193-4.613.85-15.293 39.446-26.823z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M531.908 13.848c-1.863.819-3.542.164-3.542.164s-.819 1.064 1.392 1.187c0 0 .88.082.287 1.065"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M534.529 11.944s-3.337-2.723-5.446-2.56c-2.109.164-2.211.124-2.396.492-.184.369-.552 2.068.39 3.317.941 1.249 1.33.942 1.494.675.164-.266 1.494-1.044 4.013-.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.15001685999999997,
    d: "M529.284 9.378c-.068 0-.135.001-.201.006-2.109.164-2.211.123-2.396.492-.127.254-.34 1.138-.154 2.072.314-.302.963-.588 2.304-.516 2.662.143 4.218 1.229 4.218 1.229l.263.188 1.21-.905s-3.131-2.555-5.244-2.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M495.602 74.464l23.87-21.751 3.531 8.177-2.192 9.113-19.52 13.608-5.355-1.338-.223-4.908zM496.33 60.457l14.628-18.85 3.7 8.211-1.156 7.748-17.461 16.421z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M511.016 41.954s2.949 6.765 2.486 15.496l17.81-16.594 8.499-7.69-.174.115-1.098-5.319-.52-3.007-1.388.347v-1.734l-.232-1.504-1.214-2.37-.983-2.544-.231-2.14.462-2.544-.636.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M563.748 43.227s1.735 1.734 1.966 5.666c.231 3.932.174 6.65.174 6.65s-2.834 1.676-5.493.982c0 0 .462-1.156.52-2.775.058-1.62-.058-10.003-.058-10.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.15001685999999997,
    d: "M562.13 43.747l-1.272.084c.003.16.114 8.315.057 9.919-.058 1.619-.52 2.775-.52 2.775.973.254 1.968.189 2.84.006.02-.315.338-5.12.282-7.638-.058-2.602-1.387-5.146-1.387-5.146z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M584.63 114.809c.532-1.384 1.969-1.703 1.969-1.703s.106-.107-.32-1.118c-.425-1.011-.213-1.756-.213-1.756.16-5.376-.372-6.813-.372-6.813.372 0 2.076 2.022 2.076 2.022-.054-5.11-7.612-7.505-7.612-7.505 2.768 7.026 1.704 7.825 1.704 7.825 1.756-.746 1.969-1.916 1.969-1.916.32 1.916.053 5.641.053 5.641s.107 1.757-1.543.905c-1.65-.851-8.304-4.045-8.304-4.045l-.692 1.384 9.155 4.258s1.33.586.958 1.597c-.372 1.011-.585 1.17-.585 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M583.884 109.486s.266-3.725-.053-5.641c0 0-.213 1.17-1.97 1.916 0 0 1.065-.799-1.703-7.825 0 0 7.558 2.396 7.612 7.505 0 0-1.704-2.022-2.076-2.022 0 0 .532 1.437.372 6.813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M584.63 114.809c.532-1.384 1.969-1.703 1.969-1.703s.106-.107-.32-1.118c-.425-1.011-.213-1.756-.213-1.756.16-5.376-.372-6.813-.372-6.813.372 0 2.076 2.022 2.076 2.022-.054-5.11-7.612-7.505-7.612-7.505 2.768 7.026 1.704 7.825 1.704 7.825 1.756-.746 1.969-1.916 1.969-1.916.32 1.916.053 5.641.053 5.641s.107 1.757-1.543.905c-1.65-.851-8.304-4.045-8.304-4.045l-.692 1.384 9.155 4.258s1.33.586.958 1.597c-.372 1.011-.585 1.17-.585 1.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M570.684 104.47c-.21 0-.63.048-.977.321a.984.984 0 00-.367.61c-.045.265.01.576.183.937.36.75 1.077 1.025 1.664 1.103a3.606 3.606 0 001.084-.023l-.087-.441s-.434.085-.938.017c-.504-.067-1.037-.27-1.316-.851-.146-.305-.172-.52-.147-.668a.498.498 0 01.201-.328c.212-.167.59-.225.7-.225.184 0 .344-.03.644.121.3.15.73.497 1.303 1.277l.363-.267c-.598-.816-1.073-1.217-1.465-1.412-.391-.196-.71-.17-.845-.17z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M571.376 109.274s.213-3.513 2.449-4.738c0 0 .532.054.585.48.053.425-2.076 4.151-2.076 4.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.125,
    d: "M571.629 108.879s.177-2.927 2.04-3.947c0 0 .443.044.488.4.044.354-1.73 3.458-1.73 3.458z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.147,
    cy: 100.305,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M581.874 75.422s4.03.232 3.983 2.223c-.046 1.992-.648 3.937.695 4.308 1.343.37 4.122.37 4.817 1.111.694.741.694 1.575.694 1.575s-3.473-1.25-5.002-.37c-1.528.88-3.128-.51-3.38-.973-.557-1.02-.232-3.01-1.298-3.381-1.065-.37-4.446-.417-4.446-.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M552.633 48.008c.63-10.867-1.26-23.623-1.26-23.623l-.158-1.89-32.6 31.183s2.362-2.52 1.575 10.394l2.835 4.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M552.633 48.008c.63-10.867-1.26-23.623-1.26-23.623l-.158-1.89"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f1b517",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M543.911-1.2l-4.364 10.177s-1.269-1.29-2.296.048l-1.024 1.333m7.668-11.57l-8.424 7.187s1.607.83.635 2.207l-.968 1.374 1.089.802"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M532.89 7.305l5.994 4.385-1.573 2.15-5.994-4.384z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.15,
    d: "M533.023 7.966l5.19 3.797-1.035 1.417-5.19-3.797z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1b517",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M563.286 11.409l-5.922 9.356s-1.049-1.474-2.275-.316l-1.222 1.153m9.405-10.208l-9.457 5.761s1.456 1.074.278 2.28l-1.175 1.203.949.964"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M551.056 18.06l5.224 5.279-1.895 1.874-5.223-5.28z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.15,
    d: "M551.083 18.733l4.523 4.572-1.248 1.234-4.523-4.571z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f1b517",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M575.896 32.689l-7.438 8.203s-.78-1.632-2.187-.701l-1.402.927m11.015-8.446l-10.304 4.055s1.25 1.308-.117 2.294l-1.363.984.769 1.113"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M562.707 37.145l4.242 6.097-2.188 1.522-4.242-6.097z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.15,
    d: "M562.618 37.814l3.673 5.279-1.441 1.002-3.673-5.279z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M534.065 11.472l-37.87 48.098.59.463 37.87-48.098zM550.418 23.229L495.662 74.02l.51.551 54.756-50.795zM559.232 43.568L500.94 83.467l.424.619 58.293-39.898z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M552.99 23.897s-5.495-1.05-6.833-.238 2.342.86 3.059.62l-1.386 1.387s-3.154-.765-3.68-3.728c-.525-2.963 1.577-2.963 2.055-2.915.478.048 3.25.478 6.786 4.874z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M545.101 20.784c-.604.18-1.059.604-.903 1.393 0 0 .239.908.478 1.386a.304.304 0 01.073-.084c.181.283.387.533.606.753a6.4 6.4 0 01.539-.177c-.068-.104-.003-.235.263-.396.149-.09.35-.156.587-.205.998-.383 2.491.014 2.806-.034l1.673.095s-4.98-3.07-6.122-2.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M550.793 23.324s-6.125-1.831-6.125-.063"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M552.99 23.897s-5.495-1.05-6.833-.238 2.342.86 3.059.62l-1.386 1.387s-3.154-.765-3.68-3.728c-.525-2.963 1.577-2.963 2.055-2.915.478.048 3.25.478 6.786 4.874z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M552.275 23.853c-.143.69-.301 1.596-.22 2.002 1.79 4.572 4.223 4.671 3.27 10.226l1.884-.053c.204-2.577-.203-5.018-.678-6.103-.237-.543-.763-1.187-1.339-1.815-.577-.627-1.204-1.237-1.645-1.712-.882-.95-.271-2.17-.271-2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M551.106 23.414s-.332.874-.332 2.1c0 .613.083 1.313.332 2.037.249.723.46 1.44.633 2.233.347 1.588.542 3.487.587 6.38l2.998-.083c.954-5.555-1.48-5.654-3.269-10.226-.081-.406.077-1.312.22-2.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M553.276 24.228s-.61 1.22.271 2.17c.441.475 1.068 1.085 1.645 1.712.576.628 1.102 1.272 1.34 1.815.474 1.085.88 3.526.677 6.103m0 0l-4.882.136c-.046-2.894-.242-4.793-.588-6.38a19.598 19.598 0 00-.633-2.233 6.261 6.261 0 01-.332-2.037c0-1.226.332-2.1.332-2.1l2.17.814"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M553.886 36.096s.679-3.052-.881-5.764c-1.57-2.774-2.04-6.994-1.221-6.715"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.157,
    d: "M548.427 80.397l-4.218 7.38-16.665 1.24-1.575.212s-2.434 5.738-5.137 6.503c-2.703.764-20.78 6.402-20.78 6.402l-.557-4.133 11.715-3.78s3.437-1.264 4.46-2.604c1.021-1.34 9.543-9.5 9.543-9.5z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M540.959 61.578l-24.223 40.371.514.309 24.223-40.371z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M540.471 63.209s.684.647 1.533-.389c.85-1.036 3.332-5.311 3.807-6.088.475-.778 1.087-1.425.28-1.944-.805-.518-1.935.13-2.864 2.073-.928 1.943-3.98 5.311-2.756 6.348z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.15736518,
    d: "M561.907 68.754c.905-.122 2.45 1.647 2.863 4.722.413 3.075.016 5.666-.889 5.787-.33.043-.7-.257-1.058-.858l-48.357 6.505-1.018-9.136 47.977-5.7c.156-1.177.028-1.257.482-1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4cf0e",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15,
    d: "M262.965 61.762s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.082m-.727-1.057s-.206.664-.277 1.08m-.726-1.056s-.207.664-.277 1.081m-.727-1.057s-.206.664-.277 1.081m-.726-1.057s-.206.664-.277 1.082m-.726-1.057s-.207.664-.277 1.08m-.727-1.056s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.081m-.727-1.057s-.206.664-.277 1.081m-.726-1.056s-.207.664-.277 1.08m-.727-1.056s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.081m-.727-1.057s-.206.664-.277 1.081m-.726-1.056s-.206.664-.277 1.08m-.726-1.056s-.207.664-.277 1.081m-.727-1.057s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.081m-.727-1.057s-.206.665-.277 1.082m-.726-1.057s-.207.664-.277 1.08m-.727-1.056s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.081m-.727-1.057s-.206.665-.277 1.082m-.726-1.057s-.206.664-.277 1.08m-.726-1.056s-.207.664-.277 1.081m-.727-1.057s-.206.664-.277 1.081m-.726-1.057s-.207.665-.277 1.082m-.727-1.057s-.206.664-.277 1.08m-.726-1.056s-.207.664-.277 1.081m-.727-1.057s-.206.664-.277 1.081m-.726-1.057s-.207.665-.277 1.082m-.727-1.057s-.206.664-.277 1.08m-.726-1.056s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.081m-.727-1.057s-.206.665-.277 1.082m-.726-1.057s-.207.664-.277 1.08m-.727-1.056s-.206.664-.277 1.081m-.726-1.057s-.207.664-.277 1.081m-.727-1.057s-.206.665-.277 1.082m-.726-1.057s-.207.664-.277 1.08m-.727-1.056s-.206.664-.277 1.081m-.726-1.057s-.206.664-.277 1.081m-.726-1.057s-.207.665-.277 1.082m-.727-1.057s-.206.664-.277 1.08m-.726-1.056s-.207.664-.277 1.081",
    transform: "matrix(-1.0396243,0.13985207,0.13985207,1.0396243,780.1168,-25.809613) matrix(1.000553,0,0,0.70120787,-0.08578216,18.848186)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.27798235000000004,
    d: "M563.078 73.084l-48.972 6.587M563.226 74.184l-48.972 6.588M563.374 75.284l-48.972 6.588M563.448 75.834l-48.972 6.588M563.522 76.384l-48.972 6.588M563.596 76.935l-48.972 6.587M563.67 77.485l-48.972 6.588M563.744 78.035l-48.972 6.588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1573485,
    d: "M554.628 70.105a1.544 5.091-4.009 011.895 4.982 1.544 5.091-4.009 01-1.19 5.175 1.544 5.091-4.009 01-.484-.216 1.544 5.091-4.009 00.68-4.825 1.544 5.091-4.009 00-1.409-4.766 1.544 5.091-4.009 01.508-.35zM520.381 74.712a1.544 5.091-4.009 011.894 4.982 1.544 5.091-4.009 01-1.189 5.175 1.544 5.091-4.009 01-.485-.216 1.544 5.091-4.009 00.682-4.825 1.544 5.091-4.009 00-1.41-4.766 1.544 5.091-4.009 01.508-.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.1573485,
    d: "M513.207 78.799l-2.731-.184s-1.677.576-1.78 1.292c-.105.715-.163 1.776-.025 2.058.139.282 3.323.856 4.44-.147z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.696 79.906c1.092.268 3.02.16 4.476.02l-.06 1.892c-1.118 1.002-4.302.429-4.44.147-.139-.282-.08-1.343.023-2.058v-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15736518,
    d: "M513.714 75.526a1.073 4.923-3.743 01.333.2 1.07 5.213-3.989 00-.177 4.388 1.07 5.213-3.989 00.947 4.653 1.073 4.923-3.743 01-.45.584 1.073 4.923-3.743 01-1.395-4.818 1.073 4.923-3.743 01.742-5.007z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,984.9863,0.74097931)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15001685999999997,
    d: "M443.728 74.86v.033c.553.125.965.615.965 1.207v8.27l-5.847-5.848a1.235 1.235 0 01-.172-1.535l-.024-.023-2.533 2.533.01.01a1.233 1.233 0 011.646.088l5.945 5.944h-8.465c-.592 0-1.082-.41-1.207-.963h-.033v3.582h.014c.069-.62.586-1.102 1.226-1.102h8.408l-5.985 5.985a1.236 1.236 0 01-1.536.172l-.023.024 2.533 2.533.01-.01a1.233 1.233 0 01.088-1.646l5.945-5.945v8.464c0 .592-.412 1.082-.965 1.208v.033h3.583v-.014a1.233 1.233 0 01-1.102-1.227V88.03l6.083 6.084c.453.452.478 1.158.088 1.646l.01.01 2.534-2.533-.024-.024a1.235 1.235 0 01-1.536-.172l-5.985-5.985h8.407c.64 0 1.157.481 1.226 1.102h.014v-3.582h-.033a1.235 1.235 0 01-1.207.963h-8.464l5.945-5.944a1.233 1.233 0 011.646-.088l.01-.01-2.534-2.533-.023.023c.303.48.247 1.117-.171 1.535l-5.986 5.986V76.1c0-.64.481-1.157 1.102-1.226v-.014z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 86.476,
    r: 2.282,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15001685999999997,
    d: "M445.45 71.277a15.09 15.09 0 00-15.089 15.09 15.09 15.09 0 0015.09 15.09 15.09 15.09 0 0015.09-15.09 15.09 15.09 0 00-15.09-15.09zm0 3.84a11.25 11.25 0 0111.25 11.25 11.25 11.25 0 01-11.25 11.25 11.25 11.25 0 01-11.25-11.25 11.25 11.25 0 0111.25-11.25z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45,445.45132,86.297958)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.70710678,0.70710678,0.70710678,0.70710678,699.4111,-289.70556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,359.15336,-359.15336)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.37566452,0.92675572,0.92675572,-0.37566452,198.13393,-294.10752)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(113.39109,445.45132,86.297957)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(23.077806,445.45132,86.297956)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.9199734,0.39198079,0.39198079,0.9199734,821.42755,-167.70223)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.451,
    cy: 99.458,
    r: 0.482
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 556.963,
    cy: 100.305,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M498.222 68.61s5.88 2.533 6.386-1.826c0 0 3.548 4.46-1.317 7.3 0 0 2.23-3.549-5.069-3.954 0 0-1.014.101-.912-.71.101-.81.912-.81.912-.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.303 69.56c.833.074 2.733.284 5.684.874 1.31.262 2.226.1 2.87-.239.008 1.29-.572 2.725-2.567 3.888 0 0 2.23-3.548-5.068-3.953 0 0-.892.089-.919-.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M500.814 68.572l.494.074-2.027 13.584-.495-.074z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M500.615 68.543l.89.133-.408 2.736-.89-.133z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.15,
    transform: "matrix(-1,0,0,1,984.5452,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 472.443,
    cy: 104.751,
    fill: "#fff",
    rx: 3.569,
    ry: 1.681
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f1b517"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.15001685999999997,
    d: "M472.761 84.818c-.33-.016-.648.039-.736.236-.175.396.352.483.352.483v2.24c0 .703-.571 11.287-.835 13.35a7.687 7.687 0 01-.467 1.851s-2.52.302-2.387 1.444c.131 1.141 1.493 1.896 3.777 1.844 2.815-.064 3.601-.659 3.733-1.361.132-.703-.659-1.361-1.845-1.581l-.614-3.514s.131.527 1.756.176c1.625-.351 1.581-2.81 1.581-2.81s.044-7.38-.044-8.74c-.087-1.362-.834-2.02-1.888-2.416-.835-.132-1.406.044-1.493.527-.088.483-.308.615-.44.44-.131-.176 0-1.494 0-1.494s.615-.307.352-.483c-.132-.088-.472-.175-.802-.192zm2.12 2.52l.57.307.176 1.581v7.993l-.088.527-.747.615-.834-.176-.44-.527-.307-7.158-.087-2.284 1.054-.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M474.573 104.158s-.966-2.46-1.186-8.915c-.22-6.456-.307-6.983 0-7.29.307-.308 1.186-.835 1.713-.527.527.307.395.395.483 1.493.088 1.098.088 8.212.088 8.212s-.264 1.186-.923 1.142c-.658-.044-1.141-.307-1.23-.79"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M470.357 104.29s.922-1.098 1.185-3.162c.264-2.064.835-12.648.835-13.351v-2.24"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.265,
    d: "M524.804 96.618s-3.224.095-4.267 2.087c-1.043 1.991-.474 3.888.759 4.647 1.232.758 3.888 1.327 5.12.569 1.233-.76 2.087-3.225.664-3.51-1.422-.284-3.793-.758-3.508-1.706.284-.949 1.517-.949 1.517-.949z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.15,
    d: "M491.59 178.412h.597v2.147h-.597z",
    transform: "matrix(0.98736087,-0.1584882,0.21855532,0.97582456,0,0)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M570.121 86.252l-13.617 7.086.072.138.958.173 12.934-6.733z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M570.523 86.586l-7.673 13.586 1.245-.68 7.083-12.539z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.64 73.375a.375.375 0 00-.004 0 .375.375 0 00-.258.114l-12.924 12.83a.375.375 0 10.53.53l12.704-12.611v-.86a.375.375 0 00-.049-.003z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    d: "M572.558 84.398a.375.375 0 00-.257.114L559.47 97.249l1.123-.057 12.235-12.147a.375.375 0 00-.27-.647z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.951,
    cy: 109.883,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 529.652,
    cy: 105.094,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538.432,
    cy: 105.664,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.104,
    cy: 109.313,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 550.919,
    cy: 109.313,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.735,
    cy: 109.313,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.55,
    cy: 109.313,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.069,
    cy: 104.866,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.884,
    cy: 104.866,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.699,
    cy: 104.866,
    r: 2.391,
    fill: "#f1b517",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M535.734 13.089s-.187 1.876 1.408 3.002 3.471 2.346 4.222 5.536c.75 3.19.187 2.815.187 2.815l-4.972.844s.563-2.252-.657-4.034c-1.22-1.783-3.002-6.943-1.314-9.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.15001685999999997,
    d: "M535.576 12.97c-.296.726-.815 2.451.346 3.684 1.501 1.595 2.908 2.346 3.471 4.504.337 1.292.561 2.622.697 3.531l1.461-.248s.563.376-.187-2.814-2.627-4.41-4.222-5.535c-1.595-1.126-1.408-3.003-1.408-3.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M534.984 12.15s-.939 2.159.094 4.317c1.032 2.158 2.064 3.19 2.627 4.597.563 1.407 0 2.72.656 3.753"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.15,
    d: "M573.904 106.957a.2.2 0 10.063.395s3.398-.534 5.924 2.04a.2.2 0 10.285-.279c-2.671-2.722-6.272-2.156-6.272-2.156z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M579.832 110.797s-.007.534.43 1.047c.436.512 1.302 1.005 2.963 1.056l.011-.4c-1.587-.049-2.319-.504-2.67-.916-.35-.412-.334-.777-.334-.777z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    d: "M584.63 114.809c.532-1.384 1.969-1.703 1.969-1.703s.106-.107-.32-1.118c-.425-1.011-.213-1.756-.213-1.756.16-5.376-.372-6.813-.372-6.813.372 0 2.076 2.022 2.076 2.022-.054-5.11-7.612-7.505-7.612-7.505 2.768 7.026 1.704 7.825 1.704 7.825 1.756-.746 1.969-1.916 1.969-1.916.32 1.916.053 5.641.053 5.641s.107 1.757-1.543.905c-.883-.455-5.162-2.53-5.162-2.53l-.408 1.462 5.73 2.665s1.33.586.957 1.597c-.372 1.011-.585 1.17-.585 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.839 106.91c.068.127.136.26.206.404.095.004.195.01.3.018a13.166 13.166 0 00-.202-.412 8.294 8.294 0 00-.304-.01zm1.013.08c.047.132.093.268.14.418.095.016.194.037.292.057a12.51 12.51 0 00-.138-.43 8.167 8.167 0 00-.294-.046zm1.092.226c.024.137.047.28.068.434.091.028.183.059.276.092-.02-.155-.04-.3-.063-.438-.095-.03-.188-.062-.28-.088zm1.092.398c-.003.14-.007.284-.015.437.086.041.172.085.258.132a12.7 12.7 0 00.02-.437c-.088-.045-.176-.092-.264-.132zm1.006.56c-.028.136-.058.276-.092.42.077.054.155.111.232.17.036-.147.065-.286.095-.425a7.103 7.103 0 00-.235-.164zM580.476 111.465l-.19.404c.06.067.127.133.201.198l.178-.38c-.034-.035-.07-.07-.098-.103a1.608 1.608 0 01-.09-.119zm.544.498l-.05.434c.077.042.163.081.252.12l.048-.417a2.541 2.541 0 01-.25-.137zm.633.29l.08.44a5 5 0 00.28.067l-.077-.427a4.032 4.032 0 01-.283-.08zm.566.144l.186.43c.1.014.199.029.306.039l-.185-.425c-.105-.013-.212-.027-.307-.044z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M560.742 38.89s-3.007-1.445-3.7-.231c-.695 1.214-.984 3.642 0 5.088 0 0 4.278.52 6.475-.231l.29-.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#000",
    strokeWidth: 0.15001685999999997,
    d: "M557.76 40.215c-.477-.01-.934.138-1.295.307-.147 1.11-.02 2.348.576 3.225 0 0 3.788.46 6.066-.112-1.096-.344-2.984-2.154-4.273-3.068a1.896 1.896 0 00-1.074-.352z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M556.463 42.648s1.445-.983 3.758.058c2.313 1.04 2.313.867 2.313.867"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M560.742 38.89s-3.007-1.445-3.7-.231c-.695 1.214-.984 3.642 0 5.088 0 0 4.278.52 6.475-.231l.29-.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M561.609 43.805s.462 1.966.578 6.07c.116 4.106-.752 6.881-1.098 6.824"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M563.748 43.227s1.735 1.734 1.966 5.666c.231 3.932.174 6.65.174 6.65s-2.834 1.676-5.493.982c0 0 .462-1.156.52-2.775.058-1.62-.058-10.003-.058-10.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M537.903 24.955s1.387 5.725 1.56 8.384"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    strokeWidth: 0.12433949999999999,
    d: "M522.28 69.162s1.577-1.702 1.677-2.428c.1-.726.075-1.928-.902-1.953-.976-.025-5.607-.801-7.009.325-1.402 1.127-1.652 1.703-1.377 2.278.276.576 1.427 1.503 2.378 1.452.952-.05 1.878.376 2.253.15.376-.225 2.003-2.152 2.429-.425l.05.576z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b617",
    strokeWidth: 0.12433949999999999,
    d: "M517.807 75.635s.95-4.536 2.532-6.54c0 0 2.004-.527 2.742 0 .738.528-.105-.632.738.422.844 1.055.844 5.063.844 5.063l1.055.95c-2.742 1.265-7.91.105-7.91.105z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.12433949999999999,
    d: "M525.505 75.404c-2.531 1.371-7.7.317-7.7.317s-.843 2.004 0 1.687c.845-.316.423.739 1.266 0 .844-.738.844-.949.844-.949s4.852 0 5.801-.316z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.12433949999999999,
    d: "M520.877 69.75s.342.09.771.132m-.793.437s.336.085.769.12m-.791.448s.329.08.766.11m-.789.458s.323.075.764.1m-.786.468s.317.07.762.09m-.784.478s.31.066.759.079m-.78.49s.302.06.755.067m-.778.5s.297.056.753.058m-.775.51s.29.051.75.047m-.772.521s.284.046.748.037m-.77.532s.277.04.745.025M522.447 69.988c.324-.05.617-.171.787-.415m-.831.962c.363-.059.715-.193.963-.462m-1.007 1.008c.402-.066.813-.214 1.139-.509m-1.183 1.056c.442-.074.91-.236 1.314-.556m-1.358 1.103a3.564 3.564 0 001.49-.604m-1.534 1.15c.52-.09 1.106-.279 1.665-.65m-1.71 1.197a5.15 5.15 0 001.842-.698m-1.885 1.245a6.015 6.015 0 002.017-.745m-2.061 1.292a6.921 6.921 0 002.192-.793m-2.236 1.34a7.866 7.866 0 002.368-.84m-2.412 1.387a8.845 8.845 0 002.544-.888"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    strokeWidth: 0.12433949999999999,
    d: "M520.552 67.36l-1.677 1.602m.596-1.638l-1.107 1.583m.025-1.618l-.536 1.562m-.545-1.597l.035 1.542m-1.117-1.577l.606 1.522m-1.687-1.557l1.176 1.502M515.77 67.31l.727 1.426"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.15,
    d: "M527.158 13.193s1.413-1.925 5.59-.246"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.325,
    d: "M453.628 111.746c-.598 2.241-1.793 7.92-1.793 7.92 11.97 5.557 45.723 5.812 48.864 5.824v.004l.303-.002.295.002v-.004c3.15-.012 37.924-.26 49.91-5.824 0 0-1.196-5.679-1.794-7.92 0 0-1.494 5.08-48.415 5.977-46.922-.896-47.37-5.977-47.37-5.977z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.3,
    d: "M455.739 112.399c-.607-1.578-5.583-1.457-9.467-.243-3.884 1.213-6.068.85-14.443.97-8.374.122-13.108 2.064-13.836 2.307-.728.242-13.35 6.432-18.205 8.01-4.855 1.578-9.467 0-9.467 0s5.583 5.462 13.472 1.092c0 0-6.554 3.641-10.802 4.127 0 0 6.34 1.329 11.697-.986.48-.207.952-.444 1.411-.713 3.354-1.667 6.343-2.96 9.042-3.963 15.357-5.712 21.33-2.075 31.86-4.776",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1035.1984,-11.271433)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.3,
    d: "M414.554 122.707c-4.932 1.667-7.314 3.202-10.013 4.206m9.406-5.13c-4.28 1.52-6.738 2.98-9.363 3.992m8.756-4.915c-3.628 1.374-6.161 2.757-8.714 3.776m8.108-4.7c-2.977 1.228-5.585 2.535-8.065 3.562m7.458-4.485a292.844 292.844 0 01-7.415 3.347",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1035.1984,-11.271433)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.265,
    d: "M420.336 120.264s6.907-2.086 12.251-1.434m-11.47.13s6.485-1.825 12.187-1.336m-11.404.033s6.06-1.564 12.12-1.238m-11.338-.066s5.637-1.303 12.056-1.14m-11.274-.163s5.213-1.043 11.99-1.043",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1035.1984,-11.271433)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.3,
    d: "M441.841 113.877s3.117-.76 6.25-1.213c2.67-.386 5.353-.55 6.132.17M441.255 114.985s3.64-.407 6.577-1.138M440.668 116.093s4.165-.054 6.905-1.063M440.082 117.2s4.689.3 7.232-.987M439.491 118.203s5.22.582 7.568-.815",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1035.1984,-11.271433)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 0.312,
    d: "M455.711 112.166c-.72 1.395-4.85.613-7.504 1.477.64.562 2.462 1.55 7.587 2.53.85-3.19-.083-4.007-.083-4.007z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(-1.0843767,0,0,1.0843767,1035.1984,-11.271433)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    strokeLinecap: "round",
    d: "M459.209 168.022H476.9v16.52h-17.691z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    strokeLinecap: "round",
    d: "M467.953 183.887c1.16 0 2.283-.058 3.321-.165m-3.32-.72c1.16 0 2.282-.059 3.32-.166m-3.32-.72c1.16 0 2.282-.058 3.32-.165m-3.32-.72c1.16 0 2.282-.059 3.32-.165m-3.32-.72c1.16-.001 2.282-.059 3.32-.166m-3.32-.72c1.16 0 2.282-.058 3.32-.165m-3.32-.72c1.16-.001 2.282-.059 3.32-.166m-3.32-.72c1.16 0 2.282-.058 3.32-.165m-3.32-.72c1.16 0 2.282-.059 3.32-.166m-3.32-.72c1.16 0 2.282-.058 3.32-.165m-3.32-.72c1.16 0 2.282-.059 3.32-.166m-3.32-.72c1.16 0 2.282-.058 3.32-.165m-3.32-.72c1.16 0 2.282-.059 3.32-.165m-3.32-.72c1.16-.001 2.282-.059 3.32-.166m-3.32-.72c1.16 0 2.282-.058 3.32-.165",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinecap: "round",
    d: "M476.783 182.346c-.676.383-1.609.718-2.727.982m2.727-1.877c-.676.384-1.609.718-2.727.982m2.727-1.877c-.676.384-1.609.718-2.727.982m2.727-1.877c-.676.384-1.609.719-2.727.982m2.727-1.877c-.676.384-1.609.719-2.727.982m2.727-1.876c-.676.383-1.609.718-2.727.982m2.727-1.877c-.676.384-1.609.718-2.727.982m2.727-1.877c-.676.384-1.609.718-2.727.982m2.727-1.877c-.676.384-1.609.719-2.727.982m2.727-1.877c-.676.384-1.609.719-2.727.982m2.727-1.876c-.676.383-1.609.718-2.727.982m2.727-1.877c-.676.384-1.609.718-2.727.982m2.727-1.877c-.676.384-1.609.718-2.727.982m2.727-1.877c-.676.384-1.609.719-2.727.982m2.727-1.877c-.676.384-1.609.719-2.727.982",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    d: "M463.885 171.24c-1.666-.228-3.091-.589-4.126-1.04m4.126 1.93c-1.666-.226-3.091-.588-4.126-1.038m4.126 1.93c-1.666-.227-3.091-.588-4.126-1.039m4.126 1.93c-1.666-.227-3.091-.588-4.126-1.039m4.126 1.93c-1.666-.227-3.091-.588-4.126-1.038m4.126 1.93c-1.666-.228-3.091-.589-4.126-1.04m4.126 1.93c-1.666-.226-3.091-.588-4.126-1.038m4.126 1.93c-1.666-.227-3.091-.588-4.126-1.039m4.126 1.93c-1.666-.227-3.091-.588-4.126-1.038m4.126 1.93c-1.666-.228-3.091-.589-4.126-1.04m4.126 1.93c-1.666-.226-3.091-.588-4.126-1.038m4.126 1.93c-1.666-.227-3.091-.589-4.126-1.039m4.126 1.93c-1.666-.227-3.091-.588-4.126-1.039m4.126 1.93c-1.666-.227-3.091-.588-4.126-1.038m4.126 1.93c-1.666-.228-3.091-.589-4.126-1.04",
    opacity: 0.98,
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    strokeLinecap: "round",
    d: "M467.953 163.108a9.07 2.363 0 00-9.07 2.364 9.07 2.363 0 00.144.399v2.262a9.07 2.363 0 00-.144.4 9.07 2.363 0 00.144.416v.432h.463a9.07 2.363 0 008.463 1.515 9.07 2.363 0 008.455-1.515h.56v-.595a9.07 2.363 0 00.055-.253 9.07 2.363 0 00-.055-.223v-2.615a9.07 2.363 0 00.055-.223 9.07 2.363 0 00-9.07-2.364zm0 1.599a9.07 2.363 0 01.565.007 9.07 2.363 0 01.46.009 9.07 2.363 0 01.402.016 9.07 2.363 0 01.493.022 9.07 2.363 0 01.415.028 9.07 2.363 0 01.445.033 9.07 2.363 0 01.453.043 9.07 2.363 0 01.386.04 9.07 2.363 0 01.457.058 9.07 2.363 0 01.352.047 9.07 2.363 0 01.454.072 9.07 2.363 0 01.31.053 9.07 2.363 0 01.382.076 9.07 2.363 0 01.247.048h-.014a9.07 2.363 0 012.718 1.01 9.07 2.363 0 01-8.525 1.565 9.07 2.363 0 01-8.525-1.562 9.07 2.363 0 016.766-1.52 9.07 2.363 0 01.896-.034 9.07 2.363 0 01.863-.012z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinecap: "round",
    d: "M467.953 164.707a9.07 2.363 0 00-8.525 1.565 9.07 2.363 0 008.525 1.563 9.07 2.363 0 008.525-1.566 9.07 2.363 0 00-8.525-1.562z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinecap: "round",
    d: "M467.755 163.111a9.07 2.363 0 00-.727.01v1.6a9.07 2.363 0 01.727-.013zm4.97.353v1.6a9.07 2.363 0 01.728.132v-1.601a9.07 2.363 0 00-.728-.131zm-10.061.09a9.07 2.363 0 00-.727.152v1.598a9.07 2.363 0 01.727-.151zM473.695 167.297a9.07 2.363 0 01-.849.16v3.06a9.07 2.363 0 00.849-.159zm-8.364.433v3.064a9.07 2.363 0 00.848.056v-3.064a9.07 2.363 0 01-.848-.056z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    strokeLinecap: "round",
    d: "M476.968 182.933a9.718 2.362 0 01-1.343.571 9.07 2.363 0 01-7.671 1.11 9.07 2.363 0 01-7.653-1.1 9.718 2.362 0 01-1.274-.528v1.928a9.07 2.363 0 00-.144.4 9.07 2.363 0 00.144.415v.433h.463a9.07 2.363 0 008.463 1.514 9.07 2.363 0 008.455-1.514h.56v-.596a9.07 2.363 0 00.055-.253 9.07 2.363 0 00-.055-.223z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M459.21 169.6v2.648l3.246 11.877a9.07 2.363 0 00.761.136z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M465.362 170.796l-2.866 13.337a9.07 2.363 0 00.689.123l2.884-13.412a9.07 2.363 0 01-.707-.048zM473.44 170.409a9.07 2.363 0 01-.756.135l-3.51 14.045a9.07 2.363 0 00.728-.032z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "M465.353 170.795l3.583 13.804a9.07 2.363 0 00.716-.03l-3.562-13.724a9.07 2.363 0 01-.737-.05z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    strokeLinecap: "round",
    d: "M473.637 170.37a9.07 2.363 0 01-.69.132l3.512 12.423.44-.126v-.883z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinecap: "round",
    d: "M476.958 182.938a9.718 2.362 0 01-.792.375v2.99a9.07 2.363 0 00.242-.141h.55zm-14.59 1.17v3.063a9.07 2.363 0 00.793.144v-3.063a9.07 2.363 0 01-.792-.145zm7.368.458a9.07 2.363 0 01-.793.033v3.061a9.07 2.363 0 00.793-.03z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-5.4425655,-101.18788)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M494.003 4.616h1.562m-1.6-.893h1.562m-1.602-.893h1.563m-1.601-.893h1.562m-1.601-.892h1.562M493.81.152h1.562m-1.6-.893h1.562m-1.602-.893h1.563m-1.601-.893h1.562m-1.601-.892h1.562m-1.601-.893h1.562m-1.6-.893h1.561m-1.6-.893h1.562m-1.602-.892h1.563m-1.601-.893h1.562m-1.601-.893h1.562m-1.601-.893h1.562m-1.6-.893h1.562m-1.602-.892h1.563m-1.601-.893h1.562m-1.601-.893h1.562m-1.601-.893h1.562m-1.6-.892h1.561m-1.6-.893h1.562",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-32.483702,-11.271433)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#016a16",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M852.876-341.34c-14.784-1.954-19.457-.51-20.137-.255-.68.255-10.196 2.89-13.934 9.177-3.739 6.287-.85 8.666-.85 8.666-.68-1.444 1.784-6.797 1.784-6.797-1.19 2.209.34 5.947.34 5.947-.51-1.104.595-4.418.595-4.418l.85 2.634c0-1.53.764-5.183.764-5.183.085 4.758 1.02 5.608 1.02 5.608-.85-1.19.595-8.497.595-8.497-.85 4.334.51 5.268.51 5.268 0-5.098 2.463-7.732 2.463-7.732-2.634 2.974-.764 7.307-.764 7.307.255-5.013 4.078-9.006 4.078-9.006-3.569 3.824-1.444 6.372-1.444 6.372.085-3.228 5.607-7.901 5.607-7.901-2.379 2.294-2.294 5.098-2.294 5.098.935-1.785 4.503-5.268 4.503-5.268-.85 1.19-1.614 4.333-1.614 4.333l1.105-.68 3.058-3.738-1.869 2.889 1.87-.85 2.123-1.954-.934 1.274 1.53-.425 1.529-1.784-.935 1.275h2.209l.935-.935-.425 1.02 1.614.085.51-.935-.085.935h.765l.68-1.36-.256 1.36s1.785 0 2.125.424c.34.425-10.876 3.484-10.876 3.484s2.464 0 2.634.68c.17.68-5.608 1.614-5.608 1.614l2.804 1.19-5.608.764 4.079.51-7.052 1.7h6.457l-6.797 1.359 4.333.595-5.693.85 5.438.509-5.862 2.464 3.143-.51c-6.202 5.948-3.993 10.196-3.993 10.196.425-1.87 3.229-6.203 3.229-6.203-.68 5.523.85 7.477.85 7.477.17-1.529 2.123-9.346 2.123-9.346.34 1.785.51 6.882.51 6.882 1.445-1.19.85-7.137.85-7.137l2.294 2.21c-1.105-1.87-.85-6.203-.85-6.203.68.765 1.53 3.738 1.53 3.738.085-.68.764-5.692.764-5.692 0 1.784 1.36 5.268 1.36 5.268l.51-5.948c.084 1.445 1.699 4.333 1.699 4.333v-6.457l1.104 2.889.17-4.503.51 5.268.935-1.105-.765-.085.34-.17.934-5.183 1.445 2.38.51-1.53-.34-2.464c.51.17 1.274 1.7 1.274 1.7v-3.145l1.36.595 2.039-2.974-1.275 2.38 1.955-1.19-2.295 1.784 1.445.595-3.229.34v.85l2.889.254c-4.078.68-4.163 1.87-4.163 1.87l3.908-.17c-3.059-.085-5.268 2.124-5.268 2.124l4.673-.17c-4.333.34-6.117 2.039-6.117 2.039l5.438.34c-2.72-.255-5.693 2.719-5.693 2.719l3.569.085c-3.314.34-4.079 2.209-4.079 2.209l2.889.085c-2.974 1.699-3.144 4.588-3.144 4.588l3.314-2.634c-3.484 3.059-2.294 5.608-2.294 5.608l2.124-2.464c-2.974 2.888-2.294 4.928-2.294 4.928l2.21-2.38c-1.105 7.223.424 7.393.424 7.393l.51-7.307c1.869.934 3.058 5.182 3.058 5.182l-1.614-6.712c1.784 1.275 2.294 3.909 2.294 3.909.68-3.06-2.124-7.053-2.124-7.053l3.484 4.419-2.634-6.713 3.058 4.589c.085-4.334-2.379-7.053-2.379-7.053l3.739 3.23c-.17-1.36-2.124-4.929-2.124-4.929.764.595 2.209 2.38 2.209 2.38-.51-2.125-2.634-4.589-2.634-4.589 1.02.255 2.719 2.38 2.719 2.38 0-1.19-1.19-5.609-1.19-5.609l1.275 2.72-.51-4.419 1.104 1.7-.254-3.06.764.17.51-3.653-.255 3.739-.85-.34.255 2.973 2.634-2.888-1.53 5.183 2.635-2.464-2.124 4.503 3.058-3.569-2.294 5.863 2.464-2.124-2.294 4.248c1.275 0 3.824-2.804 3.824-2.804-1.275.765-3.144 5.438-3.144 5.438 1.614 0 2.719-2.889 2.719-2.889l-2.634 4.843c1.614-.51 3.399-3.569 3.399-3.569.34 1.7-2.804 7.222-2.804 7.222 1.02 0 2.634-1.359 2.634-1.359s.255-1.105-.85.935c-1.105 2.039-3.653 4.503-3.653 4.503 2.209.085 4.333-2.89 4.333-2.89.34 1.36-2.634 6.713-2.634 6.713 2.124-.17 3.908-6.117 3.908-6.117.68.764 1.105 7.647 1.275 6.797.17-.85.085-9.346.085-9.346.424.595 2.161 4.484 2.161 4.484.127-1.9-1.9-9.244-1.9-9.244l2.407 4.432-2.913-8.485 3.546 4.306-4.432-8.611 2.28 3.419c-.76-5.825-4.56-5.825-4.56-5.825 4.56-.634 4.94 5.065 4.94 5.065 1.012-.253.886-3.166.886-3.166l.253 1.393.76 4.812.506-4.179v5.192c0 .507 1.52-3.039 1.52-3.039.38.633.38 4.939.38 4.939l1.266-3.42c.76 2.027.254 5.446.254 5.446 1.266 0 1.646-3.04 1.646-3.04l1.52 4.433-.127-3.292c-.127-3.293-4.56-9.751-5.699-10.385-1.14-.633-5.572-2.026-5.572-2.026l-4.179-3.925 4.18 3.925c.506-.633-.507-3.799-.507-3.799l3.292 4.306c.76-1.52-.76-4.053-.76-4.053 1.013 1.14 3.926 5.32 3.926 5.32.38-1.52-.76-4.94-.76-4.94.887.887 4.053 6.079 4.053 6.079-.127-.507-1.9-5.699-1.9-5.699 2.153 1.9 4.306 7.978 4.306 7.978.633-2.026-.887-7.345-.887-7.345l3.673 8.738c.38-1.773-.254-5.318-.254-5.318 1.14 1.013 3.04 5.572 3.04 5.572-.254-2.66-1.013-5.952-1.013-5.952l3.292 6.078-.633-4.052 2.026 4.432-1.013-3.926 2.786 3.926-2.28-4.179 3.293 3.293s-4.812-5.952-5.825-6.839c-1.013-.886-10.004-4.179-12.03-5.192-2.027-1.013-10.891-.506-10.891-.506l2.66-.127-.507-1.14.506 1.013h1.773l-1.013-1.013.76 1.14h3.039l-2.026-1.773c1.013.507 2.026 1.646 2.026 1.646l1.52.127-1.013-2.153 1.52 2.406 2.532.507c-.38-1.14-1.9-2.913-1.9-2.913 1.013 1.013 2.28 3.04 2.28 3.04l2.153.76c0-1.14-1.773-3.673-1.773-3.673 1.52 1.266 2.786 3.926 2.786 3.926.126-1.013-.76-4.053-.76-4.053 1.013.633 2.66 4.56 2.66 4.56.126-1.14-.127-4.56-.38-4.433.76.886 2.405 5.445 2.405 5.445v-4.432c.507 0 1.9 4.812 1.9 4.812.76-1.773-.127-5.445-.127-5.445.633 1.266 2.026 5.319 2.026 5.319l.254-1.773.38 3.292.38-2.786 1.14 3.04c-.127-1.773-1.52-6.586-1.52-6.586 1.013 1.013 3.672 6.965 3.672 6.965v-2.152l.76 3.419c1.14-3.42-1.266-7.219-1.266-7.219 1.772 2.533 2.406 5.826 2.406 5.826l.76-1.773c.76 1.266.76 4.559.76 4.559 1.012-3.546-1.014-6.712-1.014-6.712 2.153 1.646 3.42 8.358 3.42 8.358l.38-5.192c.632 1.266 1.834 5.211 1.834 5.211.29-2.197-.636-5.897-1.85-7.516-1.214-1.62-2.197-3.296-9.83-4.915-7.632-1.619-26.077-.231-26.077-.231l2.95-.636c1.907-1.504 6.302-.231 6.302-.231l1.098.057s-.173-1.272-.231-1.734c-.058-.463 2.082 1.503 2.082 1.503l.751.058v-2.197l3.123 2.37 1.156.174-2.024-2.718c1.157 1.099 4.626 2.486 4.626 2.486-.231-.982-2.833-3.064-2.833-3.064.867 0 4.452 3.238 4.452 3.238l-2.14-2.486 5.146 2.428c-.346-.636-2.081-2.428-2.081-2.428 2.024 1.85 6.187 2.948 6.187 2.948l-4.915-3.931 6.129 4.799c-.983-3.007-3.99-5.667-3.99-5.667 1.504.232 7.228 5.898 7.228 5.898 0-2.255-2.14-4.915-2.14-4.915 1.504.52 5.32 5.725 5.32 5.725.173-1.388-2.024-5.03-2.024-5.03 1.157.577 4.279 5.087 4.279 5.087.694-2.602-2.255-4.914-2.255-4.914l5.92 3.251c-3.087-4.63-9.317-6.173-10.06-6.458-.743-.286-6.23-.286-10.974-.115-4.744.172-10.803 2.915-11.088 2.972-.286.058-5.145 1.544-5.145 1.544l-1.314-.515 1.657.4 2.287-.628-2.287-1.43 2.973 1.144 1.543-.572-2.23-1.314 2.401 1.086 3.544-1.315-4.058-1.543 6.401.057-4.858-1.715 7.888 1.315c-.686-.857-2.915-1.6-2.915-1.6 1.6 0 5.258.857 5.258.857-.686-.8-3.83-2.23-3.83-2.23 1.715.344 6.288 1.715 6.288 1.715l-3.372-2.343c.457.171 3.257 1.257 3.257 1.257-.571-1.028-2.4-1.886-2.4-1.886.743 0 6.23 2.687 6.23 2.687-1.2-1.944-3.83-4.687-3.83-4.687l3.373 2.115-1.944-2.23 5.03 2.344c-1.715-2.4-5.544-3.772-6.687-3.944-1.143-.171-9.202.743-15.547 5.259-6.344 4.515-7.087 8.687-7.087 8.687s-6.502-14.09-17.888-14.94c0 0 1.785 1.7 5.268 2.464 0 0-3.823.85-4.758 2.209 0 0 4.248-.34 6.967.425 0 0-4.503.934-5.183 2.124 0 0 4.843-.51 7.392-.085 0 0-4.333.595-4.503 1.614 0 0 6.712 0 6.967 1.275 0 0-4.588-.17-5.777.595 0 0 6.032.85 7.222 1.699l-3.739.595s4.843 1.02 5.438 2.379c0 0-10.706-4.673-19.457-5.608-8.751-.935-11.385 1.36-12.915 2.634-1.529 1.274-5.013 4.588-4.418 7.307 0 0 1.87-3.654 6.373-6.542l-4.079 4.927 4.588-3.738s-2.803 3.823-2.803 5.098c0 0 4.333-7.052 6.202-8.327 0 0-3.144 3.994-3.059 5.523 0 0 6.033-5.947 6.627-5.862 0 0-4.588 4.163-4.503 6.882 0 0 5.268-5.608 6.882-6.118 0 0-3.993 2.294-3.228 4.248l4.333-3.993-2.634 4.248 1.275-.424s1.869-3.569 4.503-3.484l-3.484 3.314 1.784-.17s2.04-2.55 4.504-3.399c0 0-3.569 2.889-3.739 3.399l1.105.085s2.124-2.21 3.738-2.634l-1.53 2.464h.765l2.04-1.954-1.445 1.869 1.87.17 1.359-1.19-1.105 1.36h1.36l.85-.68-.086.85 2.21.085.594-1.19-.085 1.02z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-425.76596,333.57046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3187.5-1289.781l-5.78 6.742-.642.178v.787s-22.479 8.348-39.178 22.799c-16.698 14.45-26.973 30.507-28.9 38.215-1.927 7.706-2.248 29.222-2.248 29.222s3.21-17.984 5.137-20.553c0 0 0 11.24 1.605 13.809 0 0 1.286-19.588 1.928-22.478.642-2.89.641 16.056 4.174 17.662 0 0-.964-20.232 1.605-26.655 0 0-.962 10.919.965 13.809 0 0 2.89-25.37 9.633-32.113 0 0-8.029 13.167-2.89 31.793l1.548-7.1-2.19.355 2.327-.976 2.168-9.942 3.218 7.676 1.3-.545.81-6.681-8.217-.772 9.842-1.469.107-3.33-4.812-.66 4.863-.972.133-4.164h-3.711l3.74-.9.113-3.597.418 3.467 5.274-1.271.73-3.48.723 3.13.428-.103.886-5.461-1.072-.135 1.117-.152.809-4.987.63 4.791 2.493-.342 1.373-7.017 1.605 6.422s4.176-13.809 7.387-15.414l.254 8.404c.5-.095.958-.179 1.498-.285l6.918-11.973-.127 3.908c.644-.177 1.418-.393 2.72-.755l2.866-6.684 1.926 5.137 3.213-3.854 1.52 2.705c12.168-3.501 27.52-8.15 26.738-9.127-1.285-1.605-8.028-1.605-8.028-1.605l.963-5.139-2.568 5.139h-2.89l.321-3.533-1.927 3.533-6.102-.322 1.606-3.854-3.532 3.533h-8.35zm-12.03 20.31l-.173 5.38 2.228-5.2a38.658 38.658 0 00-2.054-.18zm-21.29 16.307l.595 4.53.758-.182.799-4.078zm-9.489 8.02l.471 3.906 3.525-.705.67-3.201zm.727 6.015l.338 2.807 1.81-.27.455-2.18zm-2.93 5.389l1.018 4.33.135-4.223zm3.621.34l.287 2.384.485-2.312zm-5.117 8.675l-.228.037.173.416z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0843767,0,0,1.0843767,-425.76596,333.57046) scale(0.26458333)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.325,
    d: "M502.997-51.5l-.808 11.126c.89 1.498 1.355 2.5 1.355 2.5s.152-.846.875-2.196l-.354-10.991a8.854 8.854 0 00-1.068-.439zm1.517 14.371l-.405.087.412.114z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.29,
    d: "M602.721 231.398s3.528-2.435 5.544-.102l-.672 1.725-3.444.304z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0876582,0,0,0.90056981,-187.59245,-144.7289)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "green",
    stroke: "#000",
    strokeWidth: 0.164,
    d: "M605.246 226.102l-.07 6.605.699.008.07-6.607z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0876582,0,0,0.90056981,-187.59245,-144.7289)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "green",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M602.826 233.563s.71.356.568 1.634c-.142 1.279-.426 5.896 2.273 5.896 2.7 0 2.344-4.475 2.344-5.185s.213-2.06.213-2.06v-2.558s-2.699 2.415-5.398-.07z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0876582,0,0,0.90056981,-187.59245,-144.7289)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M474.893 325.38s-.187 1.114-.186 2.23c0 .558.042 1.117.192 1.559.076.22.176.415.335.567a.846.846 0 00.12.093 2 2 0 00.534-.07l-.01-.195c-.104.004-.163-.018-.246-.098a1.051 1.051 0 01-.23-.41c-.126-.371-.176-.907-.176-1.446 0-1.079.183-2.173.183-2.173z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.567,
    d: "M2298.688 881.55c-9.234 3.645-15.933 2.451-20.292.429v.78s1.274.639 1.891 2.616c8.552 5.014 15.24.947 18.492-1.955z",
    transform: "matrix(0.79645564,0,0,0.77530405,100.0721,273.79617) matrix(1.0876582,0,0,0.90056981,-187.59245,-144.7289) scale(0.26458333)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.421,
    fontFamily: "Helvetica",
    fontSize: 6.728,
    fontWeight: 400,
    letterSpacing: 0,
    wordSpacing: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.714 363.843l-.552-.104-.789 3.987 2.63.493.095-.477-2.079-.39zM469.89 365.693l.418.067.238-1.423-.417-.067zM473.926 364.811l-.356 2.542q-.046.326-.168.522-.126.206-.307.307-.359.192-.768.132-.183-.024-.36-.106-.176-.08-.316-.223-.131-.143-.194-.375-.068-.226-.022-.552l.355-2.531-.557-.074-.376 2.685q-.088.582.239 1.052.324.483 1.146.604.854.102 1.323-.287.466-.379.554-1.011l.367-2.61zM477.647 368.51l-.011-.002-1.725-3.47-.663-.068-.433 4.038.542.055.35-3.263h.01l1.762 3.478.63.064.432-4.038-.545-.055zM480.003 365.422l-.563-.048-.36 4.045.563.048zM484.014 367.752q-.058.722-.471 1.153-.416.436-1.099.394-.684-.053-1.027-.542-.354-.484-.301-1.206.054-.732.475-1.157.41-.432 1.095-.39.681.053 1.03.537.346.478.298 1.211zm.577.04q.025-.338-.038-.717-.078-.379-.286-.712-.209-.344-.581-.574-.388-.224-.965-.27-.286-.02-.533.013-.247.036-.45.122-.405.176-.667.488-.252.3-.378.666-.132.364-.157.703-.024.328.054.702.072.373.277.717.214.341.59.572.372.236.952.282.294.02.542-.026.247-.033.453-.12.403-.178.658-.487.256-.311.388-.67.117-.36.141-.688zM487.913 369.213h-.012l-1.906-3.38-.665-.035-.22 4.055.545.027.177-3.276h.01l1.944 3.385.631.033.22-4.055-.548-.028zM491.601 368.295l2.045.065.016-.486-2.044-.065.041-1.242 2.322.073.017-.485-2.887-.091-.135 4.058.564.017zM496.402 369.08l.388 1.189.615.011-1.428-4.087-.639-.012-1.649 4.03.579.01.46-1.173zm-1.491-.515l.705-1.774h.011l.58 1.798zM498.634 366.225l-.565-.004-.033 4.06.565.004zM499.032 366.72l1.41-.018.048 3.573.564-.006-.048-3.574 1.413-.018-.007-.486-3.387.043zM505.078 366.123l-.561.017.13 4.058 2.676-.081-.015-.486-2.116.064zM510.157 368.817l.464 1.164.615-.026-1.69-3.993-.637.027-1.386 4.123.578-.024.384-1.2zm-1.521-.422l.589-1.814h.011l.695 1.76zM513.873 367.96l2.041-.128-.032-.485-2.041.127-.082-1.24 2.319-.145-.032-.485-2.882.18.267 4.052.563-.036zM520.007 367.329q.056.722-.284 1.21-.343.492-1.024.553-.684.05-1.1-.382-.426-.426-.488-1.147-.062-.732.286-1.215.337-.487 1.021-.548.682-.05 1.103.377.417.42.486 1.152zm.576-.047q-.029-.338-.15-.702-.137-.364-.396-.661-.26-.31-.665-.481-.418-.163-.995-.122-.286.023-.525.092-.238.072-.425.187-.373.235-.582.582-.202.335-.27.715-.072.38-.043.718.027.328.163.685.13.358.388.667.265.306.672.478.406.178.986.137.294-.024.532-.107.239-.07.428-.187.37-.235.574-.579.204-.346.277-.72.06-.374.031-.702zM521.857 367.443l1.356-.144q.249-.026.41.02.154.045.24.145.087.093.124.22.031.127.046.256.015.137.075.465.03.152.064.296.033.143.073.242l.688-.073-.01-.09q-.13-.06-.181-.14-.049-.08-.073-.242l-.115-.727q-.035-.207-.087-.344-.06-.132-.14-.196-.077-.078-.163-.113-.092-.032-.192-.055.095-.066.19-.162.09-.084.166-.2.075-.123.108-.284.028-.162.004-.381-.082-.628-.517-.82-.434-.183-.967-.12l-1.918.203.452 4.036.56-.06zm-.206-1.837l1.396-.148q.231-.03.49.048.124.05.215.177.092.132.118.368.025.22-.03.362-.055.15-.169.235-.113.087-.26.124-.146.05-.306.066l-1.3.138zM528.622 365.502q-.134-.52-.612-.847-.476-.332-1.278-.232-.905.137-1.325.773-.428.642-.294 1.59.179 1.143.822 1.564.618.422 1.35.315.127-.018.38-.092.252-.077.523-.262.273-.192.466-.556.194-.359.205-.927l-.542.075q-.017.352-.12.589-.106.238-.265.38-.158.136-.322.21-.167.07-.31.09-.754.1-1.137-.339-.377-.422-.477-1.147-.111-.794.226-1.253.315-.449.89-.529.16-.022.338-.024.176.009.358.075.18.068.336.216.156.146.248.406zM532.736 367.15l-2.469.458-.262-1.334 2.244-.418-.094-.477-2.244.417-.24-1.22 2.43-.453-.093-.477-2.985.555.783 3.988 3.024-.562z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHt);
export default __webpack_public_path__ + "static/media/ht.14c011ddf6971b8a2153a92e34052331.svg";
export { ForwardRef as ReactComponent };